//@ts-nocheck
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Link,
  useLocation,
  useMatch,
  useNavigate,
  useParams,
} from "react-router-dom";
import {
  ActivityIcon,
  BackIcon,
  BrandIcon,
  CalenderIcon,
  ChevronDownIcon,
  CrossIcon,
  DocumentIcon,
  MessageIcon,
  NotebookIcon,
  ReviewIcon,
  RouteIcon,
  TeamDiscussionIcon,
  EvaluationIcon,
  SparkleIconComponent,
  AiInterviewIcon,
} from "../icons/Icons";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
  Transition,
} from "@headlessui/react";
import { fetchJobPipelineDetailsData } from "../../features/pipeline/pipelineSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  fetchApplicationByDetails,
  fetchApplicationByListData,
  fetchApplicationByListDataFilter,
  updateApplicationAiData,
  UpdateJobApplicationByList,
  UpdateJobApplicationByListForApplication,
} from "../../features/ApplicationData/ApplicationDataSlice";
import CandidateDetails from "./CandidateDetails";
import JobEducationSection from "./JobEducationSection";
import JobExperienceSection from "./JobExperienceSection";
import JobResumeSection from "./JobResumeSection";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
} from "@headlessui/react";
import JobEduLocationModal from "./JobEduLocationModal";
import JobWorkplaceTypeListbox from "./JobWorkplaceTypeListbox";
import { toast } from "sonner";
import JobMessageSection from "./JobMessageSection";
import JobTeamDiscussion from "./JobTeamDiscussion";
import { motion } from "framer-motion";
import CandidateLayoutFilter from "./CandidateLayoutFilter";
import JobSkillScorecard from "./JobSkillScorecard";
import JobSkillScorecardEdit from "./JobSkillScorecardEdit";
import ApplicationQuestionnaireSection from "./Questionnaire/ApplicationQuestionnaireSection";
import ApplicationEvaluationSection from "./Evaluation/ApplicationQuestionnaireSection";
import QuestionSetDetails from "./Questionnaire/QuestionSetDetails";
import MeetingSection from "./ApplicationMeeting/MeetingSection";
import MeetingDetails from "./ApplicationMeeting/MeetingDetails";
import AppReviewSection from "./ApplicationAppReview/AppReviewSection";
import AppReviewDetails from "./ApplicationAppReview/AppReviewDetails";
import AppEvaluationDetails from "./ApplicationAppReview/AppEvaluationDetails";
import CandidateReviewLayout from "./candidateReview/CandidateReviewLayout";
import Journey from "./Journey";
import { _baseRequest, COMMON } from "../../utils/baseApi";
import SkillsInput from "../common/SkillsInput";
import JobActivity from "./Activity/JobActivity";
import ChangeLayoutPanel from "./ChangeLayout/ChangeLayoutPanel";
import { setChatbotOpen } from "../../features/ui/uiSlice";
import AiWidgetsComponent from "../dashboard/AiWidgets";
import CandidateAiInterview from "../../components/job/JobAiInterview"

interface CandidateLayoutProps {
  children: React.ReactNode;
}

interface FilterOption {
  id: string;
  name: string;
  value: string;
}

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

const CustomDropdown = ({
  label,
  value,
  onChange,
  options,
  name,
  placeholder = "Select...",
}) => {
  const selectedOption = options.find((opt) => opt.value === value);

  const handleChange = (newValue) => {
    onChange({
      target: {
        name: name,
        value: newValue,
      },
    });
  };

  return (
    <div className="grid gap-[6px]">
      {label && (
        <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
          {label}
        </label>
      )}
      <Listbox value={value} onChange={handleChange}>
        <div className="relative">
          <Listbox.Button className="relative w-full cursor-pointer rounded-lg bg-white py-[5px] pl-3 pr-10 text-left border border-gray-200 focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2">
            <span
              className={`block truncate text-[14px] ${
                !selectedOption ? "text-gray-400" : "text-gray-900"
              }`}
            >
              {selectedOption ? selectedOption.label : placeholder}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronDownIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={React.Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute overflow-auto h-[150px] z-10 mt-[9px] left-[0px] bg-white max-w-[100%] min-w-[100%] w-full rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
              {options.map((option) => (
                <Listbox.Option
                  key={option.value}
                  value={option.value}
                  className={({ active, selected }) =>
                    `relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 ${
                      active ? "bg-gray-200 text-[#1d2025]" : "text-gray-900"
                    }`
                  }
                >
                  {({ selected }) => (
                    <span
                      className={`block truncate text-[14px] ${
                        selected ? "font-medium" : "font-normal"
                      }`}
                    >
                      {option.label}
                    </span>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
};

// user

const useClickOutside1User = (handler) => {
  const ref = useRef(null);
  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);

  return ref;
};

const UserAssignedDropdown = ({
  assignUserList,
  onUserSelect,
  currentlyAssignedUser,
}) => {
  const [searchTerm1, setSearchTerm1] = useState("");
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);

  const dropdownRef = useClickOutside1User(() => {
    setIsDropdownOpen1(false);
    setSearchTerm1("");
  });

  // Memoized filtered users based on search term
  const filteredUsers = useMemo(() => {
    return assignUserList.filter((user) =>
      user.name.toLowerCase().includes(searchTerm1.toLowerCase()),
    );
  }, [assignUserList, searchTerm1]);

  const handleUserSelect = (user) => {
    onUserSelect(user);
    setIsDropdownOpen1(false);
    setSearchTerm1("");
  };

  // Handle unassign action
  const handleUnassign = () => {
    // Pass null to indicate unassign
    onUserSelect({ id: null });
    setIsDropdownOpen1(false);
    setSearchTerm1("");
  };

  const toggleDropdown = (e) => {
    // Prevent event from propagating to document
    e.stopPropagation();
    setIsDropdownOpen1(!isDropdownOpen1);
  };

  // Find current user object to display profile pic in button
  const currentUser = currentlyAssignedUser
    ? assignUserList.find((user) => user.name === currentlyAssignedUser)
    : null;

  const buttonBgColor = currentlyAssignedUser
    ? "inline-flex capitalize items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
    : "inline-flex capitalize items-center h-[24px] rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 border-dashed border border-gray-300";

  // const buttonText = currentlyAssignedUser ? `User: ${currentlyAssignedUser}` : 'Assign User';

  return (
    <div ref={dropdownRef} className="relative mt-">
      <span
        className="table-tooltip before:!bottom-[-35px] before:!left-[41px]"
        data-title="Assign user"
      >
        <button
          onClick={toggleDropdown}
          className={` w-full flex gap-x-2 items-center justify-start whitespace-nowrap rounded-lg text-sm font-medium transition-colors outline-offset-2 
            focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 
             [&_svg]:pointer-events-none [&_svg]:shrink-0 border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-8 px-2  py-2`}
        >
          {currentUser?.profile_pic ? (
            <img
              src={`${process.env.REACT_APP_API_BASE_URL}/${currentUser?.profile_pic}`}
              alt={`${currentUser?.name || "Profile"}`}
              className="h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10"
            />
          ) : (
            currentUser?.name && (
              <span
                className="bg-[#a3a3a3] flex items-center justify-center h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10
                      text-white text-[12px] font-medium capitalize line-clamp-1"
              >
                {currentUser?.name?.charAt(0).toUpperCase()}
              </span>
            )
          )}
          <span className="block truncate text-[#1b1b1b] font-normal capitalize">
            {currentlyAssignedUser ? (
              currentlyAssignedUser
            ) : (
              <div className="flex items-center gap-x-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-users-plus w-[1rem] h-[1rem] text-[#808080]"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M5 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
                  <path d="M3 21v-2a4 4 0 0 1 4 -4h4c.96 0 1.84 .338 2.53 .901" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  <path d="M16 19h6" />
                  <path d="M19 16v6" />
                </svg>
                Assign User
              </div>
            )}
          </span>
          <span className="pointer-events-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down w-[1rem] h-[1rem] text-[#808080]"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M6 9l6 6l6 -6" />
            </svg>
          </span>
        </button>
      </span>

      {isDropdownOpen1 && (
        <div className="absolute z-10 mt-[9px] left-[-16px] top-[26px] bg-white max-w-[161.05px] min-w-[161.05px] w-full overflow-hidden rounded-lg border border-border bg-popover py-1 px-0 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
          {/* <div className="p-1 border-b">
            <input
              type="text"
              placeholder="Search users..."
              value={searchTerm1}
              onChange={(e) => setSearchTerm1(e.target.value)}
              className="w-full px-2 py-0 border rounded text-[12px] focus:outline-none focus:ring-0 focus:ring-blue-500 border-none outline-none"
            />
          </div> */}
          <ul className="max-h-60 overflow-y-auto p-0">
            {currentlyAssignedUser && (
              <li
                onClick={handleUnassign}
                className="px-3 py-1.5 mx-2 hover:bg-gray-100 cursor-pointer text-[12px] leading-4 rounded-md flex items-center gap-2"
              >
                <span
                  className="bg-[#a3a3a3] flex items-center justify-center h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10
                       text-white text-[12px] font-medium capitalize line-clamp-1"
                >
                  U
                </span>
                <span className="font-normal block truncate text-[14px]">
                  Unassign
                </span>
              </li>
            )}
            {currentlyAssignedUser && <hr className="my-1 border-gray-200" />}
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <li
                  key={user.id}
                  onClick={() => handleUserSelect(user)}
                  className="px-3 py-1.5 hover:bg-gray-100  mx-2 cursor-pointer text-[12px] leading-4 rounded-md flex items-center gap-2"
                >
                  {user.profile_pic ? (
                    <img
                      src={`${process.env.REACT_APP_API_BASE_URL}/${user.profile_pic}`}
                      alt={`${user.name || "Profile"}`}
                      className="h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10"
                    />
                  ) : (
                    <span
                      className="bg-[#a3a3a3] flex items-center justify-center h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10
                       text-white text-[12px] font-medium capitalize line-clamp-1"
                    >
                      {user.name?.charAt(0).toUpperCase()}
                    </span>
                  )}
                  <span className="font-normal block truncate text-[14px]">
                    {user.name}
                  </span>
                </li>
              ))
            ) : (
              <li className="px-3 py-0 text-gray-500 text-[12px]">
                No user found
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

const CandidateLayout: React.FC<CandidateLayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { baseId, jobId, applicationId } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
  }>();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const [isOpenHeader, setIsOpenHeader] = useState(true);
  const location = useLocation();
  const currentPath = location.pathname.split("/").pop() || "overview";
  const [pipelineStages, setPipelineStages] = useState([]);
  const dispatch = useAppDispatch();
  const isChatOpen = useAppSelector((state: any) => state.ui?.isChatbotOpen);
  const allStagesOption = {
    id: "all",
    stage_name: "All Stages",
    stage_colour: "#9ca3af",
    applications: null,
  };
  const [selectedFilter, setSelectedFilter] = useState(allStagesOption);
  const [selectedFilterHeader, setSelectedFilterHeader] = useState(null);
  const optionsWithAllStagesHeader = [...pipelineStages];

  const optionsWithAllStages = [allStagesOption, ...pipelineStages];
  const [applicationList, setApplicationList] = useState([]);
  const [loadingApplicationList, setLoadingApplicationList] = useState(false);
  const [candidatesList, setCandidatesList] = useState([]);
  const [currentCandidate, setCurrentCandidate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [applicationDetails, setapplicationDetails] = useState("");
  const [locationName, setLocationName] = useState("");
  const [isOverviewOpen, setIsOverviewOpen] = useState(true);

  // New states for experience modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [workplaceType, setWorkplaceType] = useState("");
  const locations = useAppSelector((state) => state.location.locationDetails);
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [conductReview, setConductReview] = useState(false);

  // Form state for new experience
  const [newExperienceForm, setNewExperienceForm] = useState({
    company: "",
    designation: "",
    startDateMonth: "",
    startDateYear: "",
    endDateMonth: "",
    endDateYear: "",
    location: "",
    workplaceType: "",
    isCurrentJob: false,
    description: "",
  });
  // education modal
  const [isModalOpenEdu, setIsModalOpenEdu] = useState(false);
  const [isLoadingEdu, setIsLoadingEdu] = useState(false);
  const [loadingLocationEdu, setLoadingLocationEdu] = useState(false);
  const [selectedCountryEdu, setSelectedCountryEdu] = useState(null);
  const [isSkillModalOpen, setIsSkillModalOpen] = useState(false);
  const [isSkillLoading, setIsSkillLoading] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);

  // Form state for new experience
  const [newEducationForm, setNewEducationForm] = useState({
    course: "",
    university: "",
    start_month: "",
    start_year: "",
    end_month: "",
    end_year: "",
    location: "",
    branch: "",
    grade: "",
    description: "",
  });

  const [previousFilters, setPreviousFilters] = useState<string>("");
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [isLoadingApp, setIsLoadingApp] = useState(false);
  const [pipelineStageDataUser, setPipelineStageDataUser] = useState([]);
  const [applicationResponse, setApplicationResponse] = useState(null);
  const [applicationResponseLoading, setApplicationResponseLoading] =
    useState(false);

  // Extract skillId from URL path instead of using useParams
  const scorecardMatch = useMatch(
    `/${baseId}/job/${jobId}/app/${applicationId}/scorecards/:skillId/*`,
  );
  const skillId = scorecardMatch?.params?.skillId;
  const isEditMode = location.pathname.includes("/edit");

  // questionnaire
  const questionMatch = useMatch(
    `/${baseId}/job/${jobId}/app/${applicationId}/questionnaire/:questionnaireId/*`,
  );
  const QuestionsId = questionMatch?.params?.questionnaireId;

  // meeting
  const meetingMatch = useMatch(
    `/${baseId}/job/${jobId}/app/${applicationId}/meetings/:meetingId/*`,
  );
  const meetingId = meetingMatch?.params?.meetingId;

  // app review
  const appReviewMatch = useMatch(
    `/${baseId}/job/${jobId}/app/${applicationId}/appreview/:appreviewId/*`,
  );
  const appreviewId = appReviewMatch?.params?.appreviewId;

  const appEvaluationMatch = useMatch(
    `/${baseId}/job/${jobId}/app/${applicationId}/appevaluation/:evaluationUserId/*`,
  );
  const appEvaluationId = appEvaluationMatch?.params?.evaluationUserId;

  // candidate review
  const candidateReviewMatch = useMatch(
    `/${baseId}/job/${jobId}/app/${applicationId}/appreview/${appreviewId}/conduct-review`,
  );
  const isConductReview = location.pathname.includes("conduct-review");

  //
  const currentCandidateData = applicationList.find(
    (candidate) => candidate.id === applicationId,
  );
  const currentIndexNo = currentCandidateData
    ? currentCandidateData.index_no
    : null;
  const [aiRun, setAiRun] = useState(false);
  const [saveAiRun, setSaveAiRun] = useState("");
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const candidateReviewMatch1 = useMatch(
    `/${baseId}/job/${jobId}/app/${applicationId}/appreview/${appreviewId}/conduct-review/:conductReviewId/*`,
  );
  const appreviewId1 = candidateReviewMatch1?.params?.conductReviewId;
  const [changeLayoutTab, setChangeLayoutTab] = useState(() => {
    return localStorage.getItem("changeLayoutTab") === "true";
  });
  const [openDetails, setOpenDetails] = useState(false);
  const [isLoadingPrevious, setIsLoadingPrevious] = useState(false);

  useEffect(() => {
    let data = applicationDetails?.application?.stage_id;
    if (baseId) {
      const fetchJob = async () => {
        const storedBase = localStorage.getItem("jobPipelineStageData");
        if (storedBase) {
          const parsedData = JSON.parse(storedBase);
          if (parsedData && parsedData.stages) {
            setPipelineStages(parsedData.stages);
            const matchedStage = parsedData.stages.find(
              (stage) => stage.id == data,
            );
            setSelectedFilterHeader(matchedStage ?? null);
          }
        }
      };
      fetchJob();
    }
  }, [baseId, jobId, applicationDetails]);

  useEffect(() => {
    if (currentPath === "overview") {
      setIsOverviewOpen(true);
    } else {
      setIsOverviewOpen(false);
    }
  }, [currentPath]);

  // Generate nav items with dynamic routing
  const generateNavItems = (appId: string) => [
    {
      name: "Overview",
      to: `/${baseId}/job/${jobId}/app/${appId}/overview`,
      icon: BrandIcon,
      current: currentPath === "overview",
    },
    {
      name: "Resume",
      to: `/${baseId}/job/${jobId}/app/${appId}/resume`,
      icon: DocumentIcon,
      current: currentPath === "resume",
    },
    {
      name: "App Review",
      to: `/${baseId}/job/${jobId}/app/${appId}/appreview`,
      icon: ReviewIcon,
      current: currentPath === "appreview",
    },
    {
      name: "Message",
      to: `/${baseId}/job/${jobId}/app/${appId}/message`,
      icon: MessageIcon,
      current: currentPath === "message",
    },
    // {
    //   name: "Files",
    //   to: `/${baseId}/job/${jobId}/app/${appId}/files`,
    //   icon: FilesIcon,
    //   current: currentPath === "files",
    // },
    {
      name: "Team Discussion",
      to: `/${baseId}/job/${jobId}/app/${appId}/team-discussion`,
      icon: TeamDiscussionIcon,
      current: currentPath === "team-discussion",
    },
    // {
    //   name: "Notes",
    //   to: `/${baseId}/job/${jobId}/app/${appId}/notes`,
    //   icon: NoteIcon,
    //   current: currentPath === "notes",
    // },
    // {
    //   name: "ScoreCards",
    //   to: `/${baseId}/job/${jobId}/app/${appId}/scorecards`,
    //   icon: ScoreCardIcon,
    //   current: currentPath === "scorecards",
    // },
    {
      name: "Questionnaire",
      to: `/${baseId}/job/${jobId}/app/${appId}/questionnaire`,
      icon: NotebookIcon,
      current: currentPath === "questionnaire",
    },
    {
      name: "Meetings",
      to: `/${baseId}/job/${jobId}/app/${appId}/meetings`,
      icon: CalenderIcon,
      current: currentPath === "meetings",
    },
    {
      name: "Activity",
      to: `/${baseId}/job/${jobId}/app/${appId}/activity`,
      icon: ActivityIcon,
      current: currentPath === "activity",
    },
    {
      name: "Journey",
      to: `/${baseId}/job/${jobId}/app/${appId}/journey`,
      icon: RouteIcon,
      current: currentPath === "journey",
    },
    {
      name: "Evaluation",
      to: `/${baseId}/job/${jobId}/app/${appId}/evaluation`,
      icon: EvaluationIcon,
      current: currentPath === "evaluation",
    },
    {
      name: "Ai Interview",
      to: `/${baseId}/job/${jobId}/app/${appId}/ai_interview`,
      icon: AiInterviewIcon,
      current: currentPath === "ai_interview",
    },
  ];

  const navItems = generateNavItems(applicationId || "3443");
  const isScoreCardDetail = currentPath.includes("scorecards/");

  // Function to get badge styles based on rating value
  const getRatingBadgeStyles = (rating: any) => {
    if (!rating)
      return {
        bg: "bg-gray-50",
        text: "text-gray-700",
        ring: "ring-gray-700/10",
      };

    const ratingValue = parseFloat(rating);

    if (ratingValue === 5) {
      return {
        bg: "bg-green-50",
        text: "text-green-700",
        ring: "ring-green-700/10",
      };
    } else if (ratingValue === 4) {
      return {
        bg: "bg-emerald-50",
        text: "text-emerald-700",
        ring: "ring-emerald-700/10",
      };
    } else if (ratingValue === 3) {
      return {
        bg: "bg-blue-50",
        text: "text-blue-700",
        ring: "ring-blue-700/10",
      };
    } else if (ratingValue === 2) {
      return {
        bg: "bg-orange-50",
        text: "text-orange-700",
        ring: "ring-orange-700/10",
      };
    } else if (ratingValue === 1) {
      return {
        bg: "bg-red-50",
        text: "text-red-700",
        ring: "ring-red-700/10",
      };
    } else {
      return {
        bg: "bg-gray-50",
        text: "text-gray-700",
        ring: "ring-gray-700/10",
      };
    }
  };

  const getRatingLabel = (rating: any) => {
    if (!rating) return null;

    const ratingValue = parseFloat(rating);

    if (ratingValue === 5) return "Strong Yes";
    if (ratingValue === 4) return "Yes";
    if (ratingValue === 3) return "Neutral";
    if (ratingValue === 2) return "No";
    if (ratingValue === 1) return "Strong No";

    return null;
  };

  const getSkillScaleBadgeStyles = (scale: any) => {
    const scaleValue = parseFloat(scale);

    if (scaleValue >= 3.5 && scaleValue <= 4.0) {
      return {
        bg: "bg-green-50",
        text: "text-green-700",
        ring: "ring-green-700/10",
      };
    } else if (scaleValue >= 1.5 && scaleValue <= 3.4) {
      return {
        bg: "bg-blue-50",
        text: "text-blue-700",
        ring: "ring-blue-700/10",
      };
    } else if (scaleValue >= 0.5 && scaleValue <= 1.4) {
      return {
        bg: "bg-yellow-50",
        text: "text-yellow-700",
        ring: "ring-yellow-700/10",
      };
    } else if (scaleValue >= -1.5 && scaleValue <= 0.4) {
      return {
        bg: "bg-gray-50",
        text: "text-gray-700",
        ring: "ring-gray-700/10",
      };
    } else if (scaleValue >= -2.0 && scaleValue <= -1.6) {
      return {
        bg: "bg-red-50",
        text: "text-red-700",
        ring: "ring-red-700/10",
      };
    } else {
      return {
        bg: "bg-gray-50",
        text: "text-gray-700",
        ring: "ring-gray-700/10",
      };
    }
  };

  // Function to get skill level label based on scale value
  const getSkillLevelLabel = (scale: any) => {
    const scaleValue = parseFloat(scale);
    if (scaleValue >= 3.5 && scaleValue <= 4.0) return "Strong Yes";
    if (scaleValue >= 1.5 && scaleValue <= 3.4) return "Yes";
    if (scaleValue >= 0.5 && scaleValue <= 1.4) return "Neutral";
    if (scaleValue >= -1.5 && scaleValue <= 0.4) return "No";
    if (scaleValue >= -2.0 && scaleValue <= -1.6) return "Strong No";

    return null;
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    setOpenDetails(false);
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleToggleHeader = () => {
    setIsOpenHeader(!isOpenHeader);
  };

  // Handle candidate selection
  const handleCandidateSelect = (candidateId) => {
    const section = currentPath || "overview";
    const condidateId = candidateId || section;
    navigate(`/${baseId}/job/${jobId}/app/${condidateId}/overview`);
    const selectedCandidate = candidatesList.find((c) => c.id === candidateId);
    if (selectedCandidate) {
      setCurrentCandidate(selectedCandidate);
    }
  };

  // Handle back button click
  const handleBackClick = () => {
    const navigateRoute = localStorage.getItem("currentRoute");
    //  navigate(`/${baseId}/job/${jobId}/candidates`);
    // navigate(-1);
    navigate(navigateRoute);
  };

  const handleFilterChange = (option) => {
    setIsFilterLoading(true);
    setSelectedFilter(option);
    fetchDataWithOption(1, option);
  };

  const fetchDataWithOption = async (page = 1, option, isLoadMore = false) => {
    try {
      if (!isLoadMore && applicationList.length === 0) {
        setLoadingApplicationList(true);
      }

      const activeFiltersDetails = JSON.parse(
        localStorage.getItem("activeFiltersJobsDetailsPage") || "{}",
      );
      const activeFiltersJobApplication = JSON.parse(
        localStorage.getItem("activeFiltersJobApplication") || "{}",
      );

      const filters = {};

      if (option && option.id && option.id !== "all") {
        filters["stage_id"] = option.id;
      } else {
        console.log("Not adding stage_id, option:", option);
      }

      Object.entries(activeFiltersDetails).forEach(
        ([filterType, filterValues]) => {
          // Your existing code
        },
      );

      const res = await dispatch(
        fetchApplicationByListDataFilter({
          baseId,
          jobId,
          stageId:
            activeFiltersJobApplication?.Stages?.length > 0
              ? activeFiltersJobApplication.Stages[0].id
              : "",
          page,
          limit: activeFiltersJobApplication?.pagination?.pageSize || 25,
          filters,
        }),
      ).unwrap();
      if (res.status === 200) {
        setApplicationList((prevList) =>
          page === 1
            ? res.data.jobApplication || []
            : [...prevList, ...(res.data.jobApplication || [])],
        );

        setCandidatesList(res.data.jobApplication || []);
        setCurrentPage(page);
        setTotalPages(res.data.totalPages || 1);
        setHasNextPage(res.data.hasNextPage || false);

        const updatedFilters = {
          ...activeFiltersJobApplication,
          pagination: {
            ...activeFiltersJobApplication.pagination,
            currentPage: page,
          },
        };
        localStorage.setItem(
          "activeFiltersJobApplication",
          JSON.stringify(updatedFilters),
        );
      }

      // Rest of your function...
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      if (!isLoadMore && applicationList.length === 0) {
        setLoadingApplicationList(false);
      }
      setIsFilterLoading(false);
    }
  };

  const handleFilterChangeHeader = async (option) => {
    try {
      setSelectedFilterHeader(option);
      const payload = {
        baseId,
        applicationId,
        stage_id: option.id,
      };
      const res = await dispatch(UpdateJobApplicationByList(payload)).unwrap();
      if (res?.status === 200) {
        toast.success("Stage id updated successfully");
      }
    } catch (error) {
      console.error("Error updating job application list:", error);
    }
  };

  useEffect(() => {
    if (baseId) {
      const fetchJob = async () => {
        const storedBase = localStorage.getItem("jobPipelineStageData");
        if (storedBase) {
          const parsedData = JSON.parse(storedBase);
          if (parsedData && parsedData.stages) {
            setPipelineStages(parsedData.stages);
          }
        } else {
          try {
            // if (jobId) {
            const res = await dispatch(
              fetchJobPipelineDetailsData({
                baseId: Number(baseId),
                JobId: jobId,
              }),
            ).unwrap();
            if (res && res.data) {
              setPipelineStages(res?.data?.stages);
              // }
            }
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchJob();
    }
  }, [baseId, dispatch]);

  useEffect(() => {
    const checkFilterChanges = () => {
      const currentFiltersJson =
        localStorage.getItem("activeFiltersJobsDetailsPage") || "{}";

      if (currentFiltersJson !== previousFilters) {
        setPreviousFilters(currentFiltersJson);
        if (sidebarOpen) {
          fetchData(1);
        }
      }
    };

    checkFilterChanges();

    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === "activeFiltersJobsDetailsPage") {
        checkFilterChanges();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    const intervalId = setInterval(checkFilterChanges, 1000);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(intervalId);
    };
  }, [previousFilters, sidebarOpen]);

  const handleLoadPrevious = async () => {
    if (currentPage > 1) {
      try {
        setIsLoadingPrevious(true);
        const previousPage = currentPage - 1;
        await fetchData(previousPage, true);
      } catch (error) {
        console.error("Error fetching previous data:", error);
      } finally {
        setIsLoadingPrevious(false);
      }
    }
  };

  const handleLoadMore = async () => {
    if (hasNextPage) {
      setIsLoadingMore(true);
      try {
        await fetchData(currentPage + 1, true);
      } catch (error) {
        console.error("Error fetching more data:", error);
      } finally {
        setIsLoadingMore(false);
      }
    }
  };

  const fetchData = async (page = 1, isLoadMore = false) => {
    try {
      if (!isLoadMore && applicationList.length === 0) {
        setLoadingApplicationList(true);
      }

      // Retrieve filters from localStorage
      const activeFiltersDetails = JSON.parse(
        localStorage.getItem("activeFiltersJobsDetailsPage") || "{}",
      );
      const activeFiltersJobApplication = JSON.parse(
        localStorage.getItem("activeFiltersJobApplication") || "{}",
      );

      const filters = {};

      Object.entries(activeFiltersDetails).forEach(
        ([filterType, filterValues]) => {
          if (Array.isArray(filterValues) && filterValues.length > 0) {
            const keyPrefix = getKeyPrefix(filterType);

            // Handle "Created at" and "Updated at" filters differently
            if (filterType === "Created at" || filterType === "Updated at") {
              const filterObj = filterValues[0]; // Assuming only one date range is selected
              const [startDateStr, endDateStr] = (filterObj.value || "").split(
                " - ",
              );

              if (startDateStr && endDateStr) {
                const startDate = parseDate(startDateStr);
                const endDate = parseDate(endDateStr);

                // Set hours to 12:00:00 to avoid timezone issues
                startDate.setHours(12, 0, 0, 0);
                endDate.setHours(12, 0, 0, 0);

                // Format dates and add to filters
                if (filterType === "Created at") {
                  filters["submitted_from"] = formatDate(startDate);
                  filters["submitted_till"] = formatDate(endDate);
                } else if (filterType === "Updated at") {
                  filters["updated_from"] = formatDate(startDate);
                  filters["updated_till"] = formatDate(endDate);
                }
              }
            } else {
              // For other filters, use `id` or `value`
              filterValues.forEach((filter) => {
                filters[`${keyPrefix}`] = filter.id || filter.value;
              });
            }
          }
        },
      );

      // Make the API call with dynamic filters
      const res = await dispatch(
        fetchApplicationByListDataFilter({
          baseId,
          jobId,
          stageId:
            activeFiltersJobApplication?.Stages?.length > 0
              ? activeFiltersJobApplication.Stages[0].id
              : "",
          page,
          limit: activeFiltersJobApplication?.pagination?.pageSize || 25,
          filters,
        }),
      ).unwrap();

      // Handle response
      if (res.status === 200) {
        setApplicationList((prevList) =>
          page === 1
            ? res.data.jobApplication || []
            : [...prevList, ...(res.data.jobApplication || [])],
        );

        setCandidatesList(res.data.jobApplication || []);
        setCurrentPage(page);
        setTotalPages(res.data.totalPages || 1);
        setHasNextPage(res.data.hasNextPage || false);

        // Update localStorage for pagination
        const updatedFilters = {
          ...activeFiltersJobApplication,
          pagination: {
            ...activeFiltersJobApplication.pagination,
            currentPage: page,
          },
        };
        localStorage.setItem(
          "activeFiltersJobApplication",
          JSON.stringify(updatedFilters),
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      if (!isLoadMore && applicationList.length === 0) {
        setLoadingApplicationList(false);
      }
    }
  };

  const parseDate = (dateStr) => {
    return new Date(dateStr);
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getKeyPrefix = (filterType) => {
    switch (filterType) {
      case "Department":
        return "department_id";
      case "member":
        return "external";
      case "status":
        return "doc_status";
      case "subStatus":
        return "doc_sub_status";
      case "tags":
        return "doc_tag";
      case "priority":
        return "item_priority";
      case "internal":
        return "internal";
      case "Created at":
        return "submitted_from";
      case "Updated at":
        return "updated_from";
      default:
        return filterType.toLowerCase();
    }
  };

  // const fetchData = async (page = 1) => {
  //   try {
  //     setLoadingApplicationList(true);
  //     const activeFiltersJobApplication = JSON.parse(localStorage.getItem('activeFiltersJobApplication') || '{}');
  //     const stageId = activeFiltersJobApplication?.Stages?.length > 0 ? activeFiltersJobApplication.Stages[0].id : '';
  //     const limit = activeFiltersJobApplication?.pagination?.pageSize || 25;

  //     const res = await dispatch(fetchApplicationByListData({ baseId, jobId, stageId, page, limit })).unwrap();
  //     if (res.status === 200) {
  //       if (page === 1) {

  //         setApplicationList(res.data.jobApplication || []);
  //       } else {
  //         setApplicationList(prevList => [...prevList, ...res.data.jobApplication || []]);
  //         // setApplicationList(res.data.jobApplication || []);
  //       }
  //       setCandidatesList(res.data.jobApplication || []);
  //       setCurrentPage(page);
  //       setTotalPages(res.data.totalPages || 1);
  //       setHasNextPage(res.data.hasNextPage || false);
  //       // Update localStorage with the new currentPage
  //       const updatedFilters = {
  //         ...activeFiltersJobApplication,
  //         pagination: {
  //           ...activeFiltersJobApplication.pagination,
  //           currentPage: page,
  //         },
  //       };
  //       localStorage.setItem('activeFiltersJobApplication', JSON.stringify(updatedFilters));
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setLoadingApplicationList(false);
  //   }
  // };

  // const handleLoadMore = async () => {
  //   if (hasNextPage) {
  //     setIsLoadingMore(true); // Set loading state to true
  //     try {
  //       await fetchData(currentPage + 1);
  //     } catch (error) {
  //       console.error("Error fetching more data:", error);
  //     } finally {
  //       setIsLoadingMore(false); // Reset loading state
  //     }
  //   }
  // };

  // useEffect(() => {
  //   fetchData(1); // Initial load
  // }, [dispatch, baseId, jobId]);

  // const handleLoadMore = async () => {
  //   if (hasNextPage) {
  //     try {
  //       setLoadingApplicationList(true);

  //       // Fetch the next page of candidates
  //       const nextPage = currentPage + 1;
  //       const activeFiltersJobApplication = JSON.parse(localStorage.getItem('activeFiltersJobApplication') || '{}');
  //       const stageId = activeFiltersJobApplication?.Stages?.length > 0 ? activeFiltersJobApplication.Stages[0].id : '';
  //       const limit = activeFiltersJobApplication?.pagination?.pageSize || 25;

  //       const res = await dispatch(fetchApplicationByListData({ baseId, jobId, stageId, page: nextPage, limit })).unwrap();

  //       if (res.status === 200) {
  //         // Append the new candidates to the existing list
  //         setApplicationList(res.data.jobApplication || []);
  //         setCandidatesList(res.data.jobApplication || []);
  //         setCurrentPage(nextPage);
  //         setTotalPages(res.data.totalPages || 1);
  //         setHasNextPage(res.data.hasNextPage || false);

  //         // Update localStorage with the new currentPage
  //         const updatedFilters = {
  //           ...activeFiltersJobApplication,
  //           pagination: {
  //             ...activeFiltersJobApplication.pagination,
  //             currentPage: nextPage,
  //           },
  //         };
  //         localStorage.setItem('activeFiltersJobApplication', JSON.stringify(updatedFilters));

  //         // Select the first candidate from the newly loaded page
  //         if (res.data.jobApplication.length > 0) {
  //           const firstCandidateOnNextPage = res.data.jobApplication[0];
  //           setCurrentCandidate(firstCandidateOnNextPage);
  //           navigate(`/${baseId}/job/${jobId}/app/${firstCandidateOnNextPage.id}/overview`);
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     } finally {
  //       setLoadingApplicationList(false);
  //     }
  //   }
  // };

  // test
  // const handleLoadMore = async () => {
  //   try {
  //     setLoadingApplicationList(true);

  //     // Find the current candidate in the applicationList
  //     const currentCandidate = applicationList.find(candidate => candidate.id === applicationId);
  //     if (!currentCandidate) return;

  //     // Calculate the next index to start fetching from
  //     const nextIndex = currentCandidate.index_no + 1;

  //     // Fetch the next set of candidates starting from the next index
  //     const activeFiltersJobApplication = JSON.parse(localStorage.getItem('activeFiltersJobApplication') || '{}');
  //     const stageId = activeFiltersJobApplication?.Stages?.length > 0 ? activeFiltersJobApplication.Stages[0].id : '';
  //     const limit = activeFiltersJobApplication?.pagination?.pageSize || 25;

  //     const res = await dispatch(fetchApplicationByListData({ baseId, jobId, stageId, page: nextIndex, limit })).unwrap();

  //     if (res.status === 200) {
  //       // Append the new candidates to the existing list
  //       setApplicationList(prevList => [...prevList, ...res.data.jobApplication || []]);
  //       setCandidatesList(res.data.jobApplication || []);

  //       // Select the next candidate (index_no = nextIndex)
  //       if (res.data.jobApplication.length > 0) {
  //         const nextCandidate = res.data.jobApplication[0]; // First candidate in the new set
  //         setCurrentCandidate(nextCandidate);
  //         navigate(`/${baseId}/job/${jobId}/app/${nextCandidate.id}/overview`);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setLoadingApplicationList(false);
  //   }
  // };

  useEffect(() => {
    const activeFiltersJobApplication = JSON.parse(
      localStorage.getItem("activeFiltersJobApplication") || "{}",
    );

    const stageId =
      activeFiltersJobApplication?.Stages?.length > 0
        ? activeFiltersJobApplication.Stages[0].id
        : "";

    if (stageId) {
      const stage = pipelineStages.find((stage) => stage.id === stageId);
      if (stage) {
        setSelectedFilter(stage);
      }
    } else {
      setSelectedFilter(allStagesOption);
    }
  }, [pipelineStages]);

  useEffect(() => {
    const activeFiltersJobApplication = JSON.parse(
      localStorage.getItem("activeFiltersJobApplication") || "{}",
    );
    const initialPage =
      activeFiltersJobApplication?.pagination?.currentPage || 1;
    setCurrentPage(initialPage);
    // if(sidebarOpen) {
    fetchData(initialPage); // Fetch data for the initial page
    // }
  }, [baseId, jobId, sidebarOpen]);

  useEffect(() => {
    if (applicationId) {
      const fetchJob = async () => {
        setIsLoadingApp(true);
        try {
          const res = await dispatch(
            fetchApplicationByDetails({
              baseId: Number(baseId),
              jobId: jobId,
              applicationId: applicationId,
            }),
          ).unwrap();
          if (res.status === 200) {
            setapplicationDetails(res?.data);
          }
        } catch (error) {
          console.error("Error fetching base member details:", error);
        } finally {
          setIsLoadingApp(false);
        }
      };
      fetchJob();
    }
  }, [applicationId, dispatch, location.pathname]);

  useEffect(() => {
    if (applicationDetails && applicationDetails.job) {
      const locationIds = applicationDetails.job.job_location
        ? applicationDetails.job.job_location.split(",").map((id) => id.trim())
        : [];

      const baseLocationData = localStorage.getItem("baseLocationData")
        ? JSON.parse(localStorage.getItem("baseLocationData"))
        : { data: [] };

      const locationMatches = baseLocationData.data.filter((loc) =>
        locationIds.includes(loc.id),
      );

      if (locationMatches.length > 0) {
        const locationNames = locationMatches.map(
          (match) => match.location_name,
        );
        setLocationName(locationNames.join(", "));
      } else {
        setLocationName("Location not found");
      }
    }
  }, [applicationDetails]);

  const handleAddExperience = () => {
    setNewExperienceForm({
      company: "",
      designation: "",
      startDateMonth: "",
      startDateYear: "",
      endDateMonth: "",
      endDateYear: "",
      location: "",
      workplaceType: "",
      isCurrentJob: false,
      description: "",
    });
    setWorkplaceType("");
    setSelectedCountry(null);
    setIsModalOpen(true);
  };

  const handleWorkplaceTypeChange = (value) => {
    setWorkplaceType(value);
    setNewExperienceForm((prev) => ({
      ...prev,
      workplaceType: value,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewExperienceForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleLocationChange = (item) => {
    setSelectedCountry(item);
    setNewExperienceForm((prev) => ({
      ...prev,
      location: item.locationName,
    }));
  };

  const parseWorkExperience = (workString) => {
    try {
      const parsedData = JSON.parse(workString);

      return {
        ...parsedData,
        work_experience:
          parsedData.work_experience?.filter((work) => work !== null) || [],
      };
    } catch (e) {
      console.error("Error parsing work experience data:", e);
      return { work_experience: [] };
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      if (
        !newExperienceForm.company ||
        newExperienceForm.company.trim() === ""
      ) {
        toast.error("Company is required");
        setIsLoading(false);
        return;
      }
      if (
        !newExperienceForm.designation ||
        newExperienceForm.designation.trim() === ""
      ) {
        toast.error("Designation is required");
        setIsLoading(false);
        return;
      }
      const existingWorkExperience = applicationDetails.application?.app_work
        ? parseWorkExperience(applicationDetails.application.app_work)
        : { work_experience: [] };

      // Create new work experience entry
      const newWorkExperience = {
        company: newExperienceForm.company,
        designation: newExperienceForm.designation,
        startDateMonth: newExperienceForm.startDateMonth,
        startDateYear: newExperienceForm.startDateYear,
        endDateMonth: newExperienceForm.endDateMonth,
        endDateYear: newExperienceForm.endDateYear,
        location: newExperienceForm.location,
        workplace_type: newExperienceForm.workplaceType,
        isCurrentJob: newExperienceForm.isCurrentJob.toString(),
        description: newExperienceForm.description,
      };

      // Add new experience to the array
      const updatedWorkExperience = {
        ...existingWorkExperience,
        work_experience: [
          ...existingWorkExperience.work_experience,
          newWorkExperience,
        ],
      };
      const payload = {
        baseId,
        applicationId,
        app_work: JSON.stringify(updatedWorkExperience),
      };

      const response = await dispatch(
        UpdateJobApplicationByListForApplication(payload),
      ).unwrap();

      if (response.status === 200) {
        toast.success("Work experience added successfully");
        const res = await dispatch(
          fetchApplicationByDetails({
            baseId: Number(baseId),
            jobId: jobId,
            applicationId: applicationId,
          }),
        ).unwrap();

        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error("Failed to add work experience:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const years = Array.from({ length: 30 }, (_, i) => {
    const year = (2025 - i).toString();
    return { value: year, label: year };
  });

  const handleAddEducation = () => {
    setNewEducationForm({
      course: "",
      university: "",
      start_month: "",
      start_year: "",
      end_month: "",
      end_year: "",
      location: "",
      branch: "",
      grade: "",
      description: "",
    });
    setSelectedCountryEdu(null);
    setIsModalOpenEdu(true);
  };

  const handleInputChangeEducation = (e) => {
    const { name, value } = e.target;
    setNewEducationForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLocationChangeEdu = (item) => {
    setSelectedCountryEdu(item);
    setNewEducationForm((prev) => ({
      ...prev,
      location: item.locationName,
    }));
  };

  const parseEducation = (eduString) => {
    try {
      const parsedData = JSON.parse(eduString);
      return {
        ...parsedData,
        education_details:
          parsedData.education_details?.filter((edu) => edu !== null) || [],
      };
    } catch (e) {
      console.error("Error parsing education data:", e);
      return { education_details: [] };
    }
  };

  const handleSubmitEdution = async () => {
    setIsLoadingEdu(true);
    try {
      if (!newEducationForm.course || newEducationForm.course.trim() === "") {
        toast.error("Course is required");
        setIsLoadingEdu(false);
        return;
      }

      const exitingEducation = applicationDetails.application?.app_education
        ? parseEducation(applicationDetails.application.app_education)
        : { education_details: [] };

      // Create new education entry
      const newEducation = {
        course: newEducationForm.course,
        university: newEducationForm.university,
        start_month: newEducationForm.start_month,
        start_year: newEducationForm.start_year,
        end_month: newEducationForm.end_month,
        end_year: newEducationForm.end_year,
        location: newEducationForm.location,
        branch: newEducationForm.branch,
        grade: newEducationForm.grade,
        description: newEducationForm.description,
      };

      // Add new education to the array
      const updatedEducation = {
        ...exitingEducation,
        education_details: [
          ...exitingEducation.education_details,
          newEducation,
        ],
      };

      const payload = {
        baseId,
        applicationId,
        app_education: JSON.stringify(updatedEducation),
      };

      const response = await dispatch(
        UpdateJobApplicationByListForApplication(payload),
      ).unwrap();

      if (response.status === 200) {
        toast.success("Education added successfully");
        const res = await dispatch(
          fetchApplicationByDetails({
            baseId: Number(baseId),
            jobId: jobId,
            applicationId: applicationId,
          }),
        ).unwrap();

        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }
        setIsModalOpenEdu(false);
      }
    } catch (error) {
      console.error("Failed to add education:", error);
    } finally {
      setIsLoadingEdu(false);
    }
  };

  const monthsEdu = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const handleClickAiRun = async () => {
    setAiRun(true);

    try {
      const resultAction = await dispatch(
        updateApplicationAiData({
          baseId,
          appId: applicationId,
        }),
      );

      if (updateApplicationAiData.fulfilled.match(resultAction)) {
        toast.success("AI Run successfully!");
        setSaveAiRun(resultAction.payload);
      } else if (updateApplicationAiData.rejected.match(resultAction)) {
        toast.error(resultAction.payload || "Failed to run AI");
      }
    } catch (error) {
      toast.error("Failed to run AI");
    } finally {
      setAiRun(false);
    }
  };

  const handleLoadPrev = async () => {
    try {
      if (!currentCandidateData) return;
      const prevIndexNo = currentCandidateData.index_no - 1;
      if (prevIndexNo < 0) return;

      const res = await dispatch(
        fetchApplicationByListData({
          baseId,
          jobId,
          page: prevIndexNo,
          limit: 1,
        }),
      ).unwrap();
      if (res.status === 200 && res.data.jobApplication.length > 0) {
        const prevCandidate = res.data.jobApplication[0];
        navigate(`/${baseId}/job/${jobId}/app/${prevCandidate.id}/overview`);
      }
    } catch (error) {
      console.error("Error fetching previous candidate:", error);
    }
  };

  const handleLoadNext = async () => {
    try {
      const currentCandidate = applicationList.find(
        (candidate) => candidate.id === applicationId,
      );
      if (!currentCandidate) return;

      const nextIndexNo = currentCandidate.index_no + 1;
      const res = await dispatch(
        fetchApplicationByListData({
          baseId,
          jobId,
          page: nextIndexNo,
          limit: 1,
        }),
      ).unwrap();
      if (res.status === 200 && res.data.jobApplication.length > 0) {
        const nextCandidate = res.data.jobApplication[0];
        navigate(`/${baseId}/job/${jobId}/app/${nextCandidate.id}/overview`);
      }
    } catch (error) {
      console.error("Error fetching next candidate:", error);
    }
  };

  const handleFilterClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOpenFilter(!isOpenFilter);
  };

  const renderFormattedSummary = (summary) => {
    try {
      const parsed = JSON.parse(summary);
      return (
        <div className="space-y-3">
          {parsed.highlight && (
            <div>
              <p className="font-medium mb-1">Highlight:</p>
              <ul className="list-disc pl-5">
                {Array.isArray(parsed.highlight) ? (
                  parsed.highlight.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))
                ) : (
                  <li>{parsed.highlight}</li>
                )}
              </ul>
            </div>
          )}

          {parsed.strengths && (
            <div>
              <p className="font-medium mb-1">Strengths:</p>
              <ul className="list-disc pl-5">
                {parsed.strengths.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          )}

          {parsed.weaknesses && (
            <div>
              <p className="font-medium mb-1">Weaknesses:</p>
              <ul className="list-disc pl-5">
                {parsed.weaknesses.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      );
    } catch (e) {
      return <p>{summary}</p>;
    }
  };

  const styles1 = getRatingBadgeStyles(
    applicationDetails?.application?.ai_rating,
  );
  const styles = getSkillScaleBadgeStyles(
    applicationDetails?.application?.user_rating,
  );

  // Add this useEffect to populate assignUserList from localStorage with name and profile info
  useEffect(() => {
    const baseMembersDetailsString = localStorage.getItem(
      "jobByHiringTeamMembers",
    );
    if (baseMembersDetailsString) {
      const hiringTeamMembers = JSON.parse(baseMembersDetailsString) || [];
      const userList = hiringTeamMembers
        .map((member) => {
          return {
            id: member.user_id,
            name: member?.name || "Unknown User",
            profile_pic: member?.profile_pic || null,
          };
        })
        .filter((user) => user.name !== "Unknown User");
      setPipelineStageDataUser(userList);
    }
  }, []);

  const handleAssignSelect1USer = async (user, id) => {
    const payload = {
      baseId,
      applicationId,
      assign_to: user.id,
    };

    const response = await dispatch(
      UpdateJobApplicationByListForApplication(payload),
    ).unwrap();
    if (response.status === 200) {
      const res = await dispatch(
        fetchApplicationByDetails({
          baseId: Number(baseId),
          jobId: jobId,
          applicationId: applicationId,
        }),
      ).unwrap();
      if (res.status === 200) {
        setapplicationDetails(res?.data);
      }
      if (user.id) {
        toast.success("User assigned successfully!");
      } else {
        toast.success("User unassigned successfully!");
      }
    } else {
      toast.error("Failed to assign user.");
    }
  };

  let findUser =
    applicationDetails?.application?.assign_to &&
    pipelineStageDataUser.find(
      (user) => user.id === applicationDetails?.application?.assign_to,
    );

  useEffect(() => {
    const fetchInitialData = async () => {
      let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${jobId}/${applicationId}/applicationAnswers.list`;

      try {
        setApplicationResponseLoading(true);
        const response = await _baseRequest(fullUrl, "GET");

        if (response.status === 200) {
          setApplicationResponse(response?.data);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setApplicationResponseLoading(false);
      }
    };

    if (applicationId) {
      fetchInitialData();
    }
  }, [applicationId]);

  const handleAddSkills = () => {
    const parsedSkills = parseSkills(applicationDetails?.application?.skills);

    setSelectedSkills(parsedSkills);
    setIsSkillModalOpen(true);
  };

  const handleSkillsChange = (skills) => {
    setSelectedSkills(skills);
  };

  const handleSubmitSkills = async () => {
    setIsSkillLoading(true);

    if (!selectedSkills || selectedSkills.length === 0) {
      toast.error("Please select at least one skill.");
      setIsSkillLoading(false);
      return;
    }
    try {
      const updatedSkills = {
        skills: selectedSkills,
      };

      const payload = {
        baseId,
        applicationId,
        skills: JSON.stringify(updatedSkills),
      };

      const response = await dispatch(
        UpdateJobApplicationByListForApplication(payload),
      ).unwrap();

      if (response.status === 200) {
        toast.success("Skills added successfully");

        const res = await dispatch(
          fetchApplicationByDetails({
            baseId: Number(baseId),
            jobId,
            applicationId,
          }),
        ).unwrap();

        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }
        setIsSkillModalOpen(false);
      }
    } catch (error) {
      console.error("Failed to add skills:", error);
      toast.error("Failed to add skills");
    } finally {
      setIsSkillLoading(false);
    }
  };

  const parseSkills = (skills) => {
    if (!skills) return [];
    if (Array.isArray(skills)) return skills;

    try {
      const parsed = JSON.parse(skills);
      return Array.isArray(parsed) ? parsed : parsed.skills || [];
    } catch {
      return typeof skills === "string"
        ? skills
            .split(",")
            .map((skill) => skill.trim())
            .filter((skill) => skill.length > 0)
        : [];
    }
  };

  const handleClickChangeLayout = () => {
    const newValue = !changeLayoutTab;
    setChangeLayoutTab(newValue);
    localStorage.setItem("changeLayoutTab", String(newValue));

    const fetchJob = async () => {
      setIsLoadingApp(true);
      try {
        const res = await dispatch(
          fetchApplicationByDetails({
            baseId: Number(baseId),
            jobId: jobId,
            applicationId: applicationId,
          }),
        ).unwrap();

        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }
      } catch (error) {
        console.error("Error fetching application details:", error);
      } finally {
        setIsLoadingApp(false);
      }
    };

    fetchJob();
  };

  const handleOpenDetail = () => {
    setOpenDetails((prev) => !prev);
    setSidebarOpen(false);
  };

  return (
    <>
      {!isConductReview && (
        <>
          <div className="h-screen overflow-hidden">
            {/* Header */}
            <div className="sticky top-0" style={{ zIndex: 10 }}>
              <div className="flex h-[52px] shrink-0 items-center gap-x-4 bg-zinc-100  px-4 sm:gap-x-6 sm:px-6 lg:px-[14px]">
                <div className="flex items-center gap-x-2">
                  <span
                    className="table-tooltip before:!bottom-[-32px] before:!left-[17px]"
                    data-title="back"
                  >
                    <button
                      className=" relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-8 w-8"
                      onClick={handleBackClick}
                    >
                      <BackIcon />
                    </button>
                  </span>
                  <span
                    className="table-tooltip before:!bottom-[-32px] before:!left-[17px]"
                    data-title="toggle candidate list"
                  >
                    <button
                      type="button"
                      className="relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-8 w-8 "
                      onClick={toggleSidebar}
                    >
                      <span className="sr-only">Toggle sidebar</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-menu-2 w-[1rem] h-[1rem] text-[#808080]"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M4 6l16 0" />
                        <path d="M4 12l16 0" />
                        <path d="M4 18l16 0" />
                      </svg>
                    </button>
                  </span>
                </div>

                {/* <div className="h-6 w-px bg-gray-900/10" aria-hidden="true" /> */}

                <div className="flex items-center justify-between w-full">
                  <div className="flex items-center gap-x-4">
                    <div className="flex items-center gap-x-2">
                      {/* <div className='flex flex-col gap-y-[1px]'>
                  <h2 className="text-black-100 font-semibold text-sm capitalize">
                    {applicationDetails?.job?.job_title}
                  </h2>
                  <span className="text-[#1b1b1b] leading-4 text-[12px] font-normal line-clamp-2">
                  {locationName || 'Location pending'}
                  </span>
                </div> */}
                      <div className="flex flex-col gap-y-[1px]">
                        {applicationDetails ? (
                          <>
                            {/* <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize bg-gray-400">
                                {applicationDetails?.application?.app_name?.charAt(0) || currentCandidate?.name?.charAt(0)}
                              </div> */}
                            <div className="flex flex-col gap-y-[1px]">
                              <span className="text-black-100 font-semibold text-sm capitalize line-clamp-1">
                                {applicationDetails?.application?.app_name ||
                                  currentCandidate?.app_name}
                              </span>
                              <span className="text-[#1b1b1b] leading-4 text-[12px] font-normal line-clamp-1 w-[500px]">
                                {applicationDetails?.application
                                  ?.app_headline ||
                                  currentCandidate?.app_headline ||
                                  applicationDetails?.application?.app_email}
                              </span>
                            </div>
                          </>
                        ) : (
                          <>
                            {/* Skeleton for job title */}
                            {/* <div className="h-7 w-7 bg-gray-300 animate-pulse rounded-full"></div> */}
                            <div className="w-24 h-4 bg-gray-300 animate-pulse rounded"></div>
                          </>
                        )}
                      </div>
                    </div>
                    {/* <div className="h-6 w-px bg-gray-900/10" aria-hidden="true" /> */}
                  </div>
                  <div className="flex items-center gap-x-4">
                    <UserAssignedDropdown
                      assignUserList={pipelineStageDataUser}
                      onUserSelect={(user) =>
                        handleAssignSelect1USer(
                          user,
                          applicationDetails?.application?.id,
                        )
                      }
                      currentlyAssignedUser={findUser?.name}
                    />
                    <button
                      data-title={"AI review"}
                      onClick={handleClickAiRun}
                      style={{
                        transitionProperty:
                          "background-color,border-color,color,fill,stroke,opacity,box-shadow,transform",
                      }}
                      className="table-tooltip before:!bottom-[-32px] before:!left-[20px] rounded-md shadow-sm shadow-black/5 duration-200 font-[600] text-[0.8125rem] h-[32px] w-[32px] flex items-center justify-center border border-solid border-[#e7e7e8]"
                    >
                      {aiRun ? (
                        <div
                          className=" flex items-center justify-center relative z-50"
                          style={{ height: "calc(100vh - 0px)" }}
                        >
                          <div className="simple-spinner-loader [&>span]:w-[18px] [&>span]:h-[18px]">
                            <span></span>
                          </div>
                        </div>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          aria-hidden="true"
                          data-slot="icon"
                          className="w-[1.1em] h-[1.1em] text-[#000]"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                          />
                        </svg>
                      )}
                    </button>

                    {changeLayoutTab && (
                      <button
                        data-title={"Candidate Details"}
                        onClick={handleOpenDetail}
                        style={{
                          transitionProperty:
                            "background-color,border-color,color,fill,stroke,opacity,box-shadow,transform",
                        }}
                        className="table-tooltip before:!bottom-[-32px] before:!left-[20px] rounded-md shadow-sm shadow-black/5 duration-200 
                        font-[600] text-[0.8125rem] h-[32px] w-[32px] flex items-center justify-center border border-solid border-[#e7e7e8]"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-users w-[1.1em] h-[1.1em] text-[#000]"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                          <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                          <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
                        </svg>
                      </button>
                    )}

                    <button
                      data-title={"Change layout"}
                      onClick={handleClickChangeLayout}
                      style={{
                        transitionProperty:
                          "background-color,border-color,color,fill,stroke,opacity,box-shadow,transform",
                      }}
                      className="table-tooltip before:!bottom-[-32px] before:!left-[20px] rounded-md shadow-sm shadow-black/5 duration-200 
                        font-[600] text-[0.8125rem] h-[32px] w-[32px] flex items-center justify-center border border-solid border-[#e7e7e8]"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-layout w-[1.1em] h-[1.1em] text-[#000]"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M4 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
                        <path d="M4 13m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
                        <path d="M14 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
                      </svg>
                    </button>

                    <div
                      data-title="Change Stage"
                      className="max-w-[140px] min-w-[140px] w-full table-tooltip before:!bottom-[-32px] before:!left-[54px]"
                    >
                      <div
                        onClick={handleToggleHeader}
                        className=" w-full inline-flex items-center justify-start whitespace-nowrap rounded-lg text-sm font-medium transition-colors outline-offset-2
    focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 
    [&_svg]:pointer-events-none [&_svg]:shrink-0 border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-8 px-2  py-2"
                      >
                        <Listbox
                          value={selectedFilterHeader}
                          onChange={handleFilterChangeHeader}
                        >
                          <div className="relative mt-0 w-full">
                            <ListboxButton className="relative w-full bg-transparent flex items-center justify-between p-0 cursor-pointer rounded-md text-left text-gray-900 border-none">
                              {/* --- UPDATED SECTION START --- */}
                              <div className="flex items-center gap-x-[6px]">
                                {selectedFilterHeader &&
                                selectedFilterHeader.stage_name ? (
                                  // CASE 1: Value is Selected
                                  <>
                                    {selectedFilterHeader.stage_colour && (
                                      <span
                                        className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                                        style={{
                                          background:
                                            selectedFilterHeader.stage_colour,
                                        }}
                                      ></span>
                                    )}
                                    <span className="block truncate text-[#1b1b1b] font-normal">
                                      {selectedFilterHeader.stage_name}
                                    </span>
                                  </>
                                ) : (
                                  // CASE 2: No Value Selected (Placeholder)
                                  <span className="block truncate text-gray-500 font-normal">
                                    Select Stage
                                  </span>
                                )}
                              </div>
                              {/* --- UPDATED SECTION END --- */}

                              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down w-[1rem] h-[1rem] text-[#808080]"
                                >
                                  <path
                                    stroke="none"
                                    d="M0 0h24v24H0z"
                                    fill="none"
                                  />
                                  <path d="M6 9l6 6l6 -6" />
                                </svg>
                              </span>
                            </ListboxButton>

                            <ListboxOptions className="absolute z-10 mt-[9px] left-[-17px] bg-white max-w-[140px] min-w-[140px] w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
                              {optionsWithAllStagesHeader.map((option) => (
                                <ListboxOption
                                  key={option.id}
                                  value={option}
                                  className={({ active }) =>
                                    classNames(
                                      active
                                        ? "bg-gray-200 text-[#1d2025]"
                                        : "text-gray-900",
                                      "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer",
                                    )
                                  }
                                >
                                  {({ selected, active }) => (
                                    <>
                                      <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-x-[6px]">
                                          <span
                                            className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                                            style={{
                                              background: option?.stage_colour,
                                            }}
                                          ></span>
                                          <span
                                            className={classNames(
                                              selected
                                                ? "font-semibold"
                                                : "font-normal",
                                              "block truncate",
                                            )}
                                          >
                                            {option.stage_name}
                                          </span>
                                        </div>
                                      </div>
                                      {selected ? (
                                        <span
                                          className={classNames(
                                            active
                                              ? "text-white"
                                              : "text-gray-600",
                                            "absolute inset-y-0 right-0 flex items-center pr-4",
                                          )}
                                        ></span>
                                      ) : null}
                                    </>
                                  )}
                                </ListboxOption>
                              ))}
                            </ListboxOptions>
                          </div>
                        </Listbox>
                      </div>
                    </div>
                    {/* prev and next */}

                    <div className="flex items-center gap-x-2">
                      <button
                        data-title={"prev candidate"}
                        onClick={handleLoadPrev}
                        disabled={currentIndexNo === 1}
                        className={`table-tooltip before:!bottom-[-32px] before:!left-[-41px] before:!right-auto before:!translate-x-0
                   relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium transition-colors 
                  outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none
                   [&_svg]:shrink-0 border border-input bg-background
                   shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-8 w-8 ${
                     currentIndexNo === 1
                       ? "cursor-not-allowed"
                       : "hover:bg-[#f4f4f5]"
                   }`}
                      >
                        <span className="sr-only">Previous</span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-left w-[1rem] h-[1rem] text-[#808080]"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M5 12l14 0" />
                          <path d="M5 12l4 4" />
                          <path d="M5 12l4 -4" />
                        </svg>
                      </button>
                      <button
                        onClick={handleLoadNext}
                        data-title={"next candidate"}
                        disabled={currentIndexNo === applicationList.length}
                        className={`table-tooltip before:!bottom-[-32px] before:!left-[-70px] before:!right-auto before:!translate-x-0 relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium transition-colors 
                  outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none
                   [&_svg]:shrink-0 border border-input bg-background
                   shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground
                    h-8 w-8 ${
                      currentIndexNo === applicationList.length
                        ? " cursor-not-allowed"
                        : "hover:bg-[#f4f4f5]"
                    }`}
                      >
                        <span className="sr-only">Next</span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-right w-[1rem] h-[1rem] text-[#808080]"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M5 12l14 0" />
                          <path d="M15 16l4 -4" />
                          <path d="M15 8l4 4" />
                        </svg>
                      </button>
                       <button
                      type="button"
                      onClick={() => dispatch(setChatbotOpen(true))}
                      className="rounded-md duration-200 font-[600] text-[0.8125rem] h-[32px] w-[32px] flex items-center justify-center border border-solid border-[#e7e7e8]"
                      aria-label="AI Assistant"
                    >
                      <span
                        data-title={"AI Assistant"}
                        className="table-tooltip-list before:!bottom-[-35px] before:!left-[3px] before:!text-[12px]"
                      >
                        <SparkleIconComponent
                          className="w-[1rem] h-[1rem] text-[#808080]"
                          aria-hidden="true"
                        />
                      </span>
                    </button>
                    </div>

                   

                  </div>
                </div>
              </div>
            </div>

            <div className={`pb-2 lg:px-2 bg-zinc-100 ring-1 lg:ring-zinc-950/5 shadow-xs  h-[calc(100vh_-_53px)] rounded-lg mt-[1px] transition-all duration-300 ${
              isChatOpen ? 'lg:pr-[520px]' : ''
            }`}>
              <div className="flex rounded-lg h-full ring-1 lg:ring-zinc-950/5 shadow-xs ">
                {sidebarOpen && (
                  <div
                    className={`fixed inset-y-0 left-0 transform ${
                      sidebarOpen ? "translate-x-0" : "-translate-x-full"
                    } lg:relative lg:translate-x-0 transition-transform duration-300 ease-in-out lg:block`}
                    style={{ width: "300px", zIndex: 5 }}
                  >
                    <div className="h-full bg-white border-r border-gray-200 rounded-tl-lg rounded-bl-lg">
                      <div className="px-2 pb-0 pt-3 flex items-center gap-x-2 justify-between mx-[10px]">
                        {applicationDetails ? (
                          <>
                            <h2 className="text-black-100 font-medium text-sm capitalize line-clamp-1">
                              {applicationDetails?.job?.job_title}
                            </h2>
                            {/* <span className="text-[#1b1b1b] leading-4 text-[12px] font-normal line-clamp-1">
                                {locationName}
                              </span> */}
                          </>
                        ) : (
                          <>
                            {/* Skeleton for job title */}
                            <div className="w-[243px] h-4 bg-gray-300 animate-pulse rounded-md"></div>
                            {/* Skeleton for location */}
                            {/* <div className="w-24 h-3 bg-gray-300 animate-pulse rounded-md mt-1"></div> */}
                          </>
                        )}
                      </div>
                      <div className="bg-[#e0e0e0] w-full h-[1px] mt-3 mb-1"></div>
                      <div className="px-2 pb-2 pt-3 flex items-center gap-x-2 justify-between mx-[10px]">
                        <div
                          onClick={handleToggle}
                          className="w-[82%] inline-flex items-center justify-start whitespace-nowrap rounded-lg text-sm font-medium transition-colors outline-offset-2
                          focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 
                          [&_svg]:pointer-events-none [&_svg]:shrink-0 border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-8 px-4  py-2"
                        >
                          <Listbox
                            value={selectedFilter}
                            onChange={handleFilterChange}
                          >
                            <div className="relative mt-0 w-full">
                              <ListboxButton className="relative w-full bg-transparent flex items-center justify-between p-0 cursor-pointer rounded-md text-left text-gray-900 border-none">
                                <div className="flex items-center gap-x-[6px] w-full">
                                  {selectedFilter?.stage_colour && (
                                    <span
                                      className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] 
                            border-none text-[0.625rem] font-medium text-white capitalize"
                                      style={{
                                        background:
                                          selectedFilter?.stage_colour,
                                      }}
                                    ></span>
                                  )}
                                  {selectedFilter.stage_name && (
                                    <span className="block truncate text-[#1b1b1b] font-normal">
                                      {selectedFilter.stage_name}
                                    </span>
                                  )}
                                  {selectedFilter?.applications !== undefined &&
                                    selectedFilter?.applications !== null && (
                                      <span className="inline-flex w-fit items-center rounded-md bg-gray-50 px-[6.5px] py-0 h-[20px] text-[11px] font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                                        {selectedFilter?.applications}
                                      </span>
                                    )}
                                </div>

                                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down w-[1rem] h-[1rem] text-[#808080]"
                                  >
                                    <path
                                      stroke="none"
                                      d="M0 0h24v24H0z"
                                      fill="none"
                                    />
                                    <path d="M6 9l6 6l6 -6" />
                                  </svg>
                                </span>
                              </ListboxButton>

                              <ListboxOptions className="absolute z-10 mt-[9px] left-[-16px] bg-white max-w-[191.05px] min-w-[191.05px] w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
                                {optionsWithAllStages.map((option) => (
                                  <ListboxOption
                                    key={option.id}
                                    value={option}
                                    className={({ active }) =>
                                      classNames(
                                        active
                                          ? "bg-gray-200 text-[#1d2025]"
                                          : "text-gray-900",
                                        "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                                      )
                                    }
                                  >
                                    {({ selected, active }) => (
                                      <>
                                        <div className="flex items-center justify-between">
                                          <div className="flex items-center gap-x-[6px]">
                                            <span
                                              className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] 
                                  border-none text-[0.625rem] font-medium text-white capitalize"
                                              style={{
                                                background:
                                                  option?.stage_colour,
                                              }}
                                            ></span>
                                            <span
                                              className={classNames(
                                                selected
                                                  ? "font-semibold"
                                                  : "font-normal",
                                                "block truncate",
                                              )}
                                            >
                                              {option.stage_name}
                                            </span>
                                          </div>
                                          {option?.applications !== undefined &&
                                            option?.applications !== null && (
                                              <span className="inline-flex w-fit items-center rounded-md bg-gray-50 ml-2 px-[6.5px] py-0 h-[20px] text-[11px] font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                                                {option?.applications}
                                              </span>
                                            )}
                                        </div>
                                        {selected ? (
                                          <span
                                            className={classNames(
                                              active
                                                ? "text-white"
                                                : "text-gray-600",
                                              "absolute inset-y-0 right-0 flex items-center pr-4",
                                            )}
                                          >
                                            {/* <CheckIconrelative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6 className="h-5 w-5" aria-hidden="true" /> */}
                                          </span>
                                        ) : null}
                                      </>
                                    )}
                                  </ListboxOption>
                                ))}
                              </ListboxOptions>
                            </div>
                          </Listbox>
                        </div>
                        <span
                          className="table-tooltip before:!bottom-[-32px] before:!left-[20px]"
                          data-title="filter"
                        >
                          <button
                            onClick={handleFilterClick}
                            className=" relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-8 w-8"
                          >
                            <svg
                              stroke="currentColor"
                              fill="none"
                              strokeWidth={2}
                              viewBox="0 0 24 24"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              aria-hidden="true"
                              focusable="false"
                              height="1em"
                              width="1em"
                              className="text-[#0000007a]"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                            </svg>
                          </button>
                        </span>
                        {isOpenFilter && (
                          <div
                            className="fixed left-[250px] inset-0 z-50"
                            onClick={() => setIsOpenFilter(false)}
                          >
                            <motion.div
                              initial={{ x: "0px" }} // Start at 300px from the left
                              animate={{ x: "0px" }} // Move to the right edge of the container
                              exit={{ x: "-100%" }}
                              transition={{ duration: 0.3 }}
                              className="fixed left-[253px] top-2 w-[800px] bg-white shadow-lg p-4 rounded-md border border-solid border-gray-200"
                              style={{ height: "calc(100% - 200px)" }}
                              onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
                            >
                              {/* <button className="absolute top-[22px] right-[12px]" onClick={() => setIsOpenFilter(false)}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-x w-[1rem] h-[1rem] text-[#808080]"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M18 6l-12 12" />
                            <path d="M6 6l12 12" />
                          </svg>

                        </button> */}
                              {/* Drawer Content (Same as image) */}
                              {/* <h2 className="#text-[#111827] leading-[1.2] text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] font-semibold">Filters</h2> */}
                              <CandidateLayoutFilter
                                setIsOpenFilter={setIsOpenFilter}
                              />
                            </motion.div>
                          </div>
                        )}
                      </div>

                      <div className="px-2 pb-2 overflow-y-auto max-h-[calc(100vh-162px)]">
                        {loadingApplicationList ? (
                          <>
                            {Array.from({ length: 5 }).map((_, index) => (
                              <div
                                key={index}
                                className="flex items-center gap-x-2 py-[6px] px-4 animate-pulse mb-4"
                              >
                                <div className="h-7 w-7 rounded-full bg-gray-300"></div>
                                <div className="flex flex-col">
                                  <div className="w-32 h-4 bg-gray-300 rounded"></div>
                                  <div className="w-24 h-3 bg-gray-200 rounded mt-1"></div>
                                </div>
                              </div>
                            ))}
                          </>
                        ) : isFilterLoading ? (
                          <div
                            className="flex items-center justify-center relative z-50"
                            style={{ height: "calc(100vh - 130px)" }}
                          >
                            <div className="simple-spinner-loader">
                              <span></span>
                            </div>
                          </div>
                        ) : Array.isArray(applicationList) &&
                          applicationList.length > 0 ? (
                          <>
                            {currentPage > 1 && (
                              <div className="flex justify-center mt-1 mb-[6px]">
                                <button
                                  className="text-blue-500 leading-5 text-[12px] rounded-[60px] py-1 hover:ring-1 px-3 ring-inset ring-gray-500/10"
                                  onClick={handleLoadPrevious}
                                >
                                  {isLoadingPrevious ? (
                                    <span className="flex items-center gap-x-2">
                                      <div className="simple-spinner-load">
                                        <span></span>
                                      </div>
                                      Load Previous
                                    </span>
                                  ) : (
                                    "Load Previous"
                                  )}
                                </button>
                              </div>
                            )}
                            {applicationList.map((candidate, index) => (
                              <div
                                key={candidate.id}
                                className={`py-[6px] px-[14px] flex items-center gap-x-3 mb-1 hover:bg-[#00000014] ${
                                  candidate.id === applicationId
                                    ? "bg-[#00000014]"
                                    : ""
                                } rounded-md cursor-pointer`}
                                onClick={() =>
                                  handleCandidateSelect(candidate.id)
                                }
                              >
                                {/* <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize bg-gray-400">
                                    {candidate.app_name?.charAt(0) || 'N'}
                                  </div> */}
                                <div>
                                  <div className="text-black-100 font-medium text-[13px] capitalize line-clamp-1">
                                    {candidate?.app_name || "No Name"}
                                  </div>
                                  {candidate?.app_headline ? (
                                    <span className="text-[#1b1b1b] leading-4 text-[12px] font-normal line-clamp-1 mt-[0px]">
                                      {candidate.app_headline}
                                    </span>
                                  ) : candidate?.app_email ? (
                                    <span className="text-[#1b1b1b] leading-4 text-[12px] font-normal line-clamp-1 mt-[0px]">
                                      {candidate.app_email}
                                    </span>
                                  ) : null}
                                </div>
                              </div>
                            ))}
                            {hasNextPage && (
                              <div className="flex justify-center mt-4">
                                <button
                                  className="text-blue-500 leading-5 text-[12px] rounded-[60px] py-1 hover:ring-1 px-3 ring-inset ring-gray-500/10"
                                  onClick={handleLoadMore}
                                  disabled={isLoadingMore}
                                >
                                  {isLoadingMore ? (
                                    <span className="flex items-center gap-x-2">
                                      <div className="simple-spinner-load">
                                        <span></span>
                                      </div>
                                      Load More
                                    </span>
                                  ) : (
                                    "Load More"
                                  )}
                                </button>
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="text-center py-4 text-gray-500">
                            No candidates found with this filter
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* change layout */}
                {changeLayoutTab && (
                  <ChangeLayoutPanel
                    isOpenHeader={isOpenHeader}
                    setIsOpenHeader={setIsOpenHeader}
                    selectedFilterHeader={selectedFilterHeader}
                    setSelectedFilterHeader={setSelectedFilterHeader}
                    optionsWithAllStagesHeader={optionsWithAllStagesHeader}
                    applicationDetails={applicationDetails}
                    setapplicationDetails={setapplicationDetails}
                    isConductReview={isConductReview}
                    appreviewId={appreviewId}
                    appreviewId1={appreviewId1}
                    QuestionsId={QuestionsId}
                    sidebarOpen={sidebarOpen}
                    setIsLoadingApp={setIsLoadingApp}
                    isLoadingApp={isLoadingApp}
                    styles1={styles1}
                    styles={styles}
                    getRatingLabel={getRatingLabel}
                    openDetails={openDetails}
                    setOpenDetails={setOpenDetails}
                  />
                )}
                {!changeLayoutTab && (
                  <div className="flex-1">
                    <div className="flex h-full overflow-hidden">
                      <>
                        <div
                          className={`max-w-[225px] w-full border-r border-gray-200 pt-0 bg-white ${
                            !sidebarOpen
                              ? "rounded-tl-lg rounded-bl-lg"
                              : "rounded-tl-none rounded-bl-none"
                          }`}
                        >
                          <ul role="list" className="mx-2">
                            {navItems.map((item) => {
                              const isActive =
                                location.pathname === item.to ||
                                location.pathname.endsWith(
                                  item.name.toLowerCase().replace(" ", "-"),
                                );
                              return (
                                <li
                                  key={item.name}
                                  className="h-[32px] first:mt-[1rem] mb-[2px] py-[2px] sidebar-nav"
                                >
                                  <Link
                                    to={item.to}
                                    className={classNames(
                                      isActive
                                        ? "text-black-100 bg-gray-200 hover:bg-gray-300"
                                        : "text-black-100 hover:text-black-100 hover:bg-gray-100",
                                      "group flex gap-x-[10px] p-0 text-[13px] mx-0 min-h-[32px] w-full cursor-pointer leading-5 items-center rounded-[0.375rem] font-medium text-wedges-gray-900 focus:outline-none px-2",
                                    )}
                                  >
                                    <item.icon
                                      aria-hidden="true"
                                      className={classNames(
                                        isActive
                                          ? "text-[#0000007a]"
                                          : "text-[#0000007a] group-hover:text-black-100",
                                        "h-[1.1em] w-[1.1em] shrink-0",
                                      )}
                                    />
                                    {item.name}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                        {isOverviewOpen && (
                          <>
                            {isLoadingApp ? (
                              <div className="flex items-center justify-center h-[calc(100vh_-_56px)] w-full bg-white">
                                <div className="simple-spinner-loader">
                                  <span></span>
                                </div>
                              </div>
                            ) : (
                              <div className="flex-1  py-[34px] lg:py-[50px] px-0 lg:px-10 bg-white overflow-auto h-[calc(100vh_-_60px)]">
                                <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center h-auto">
                                  <div className="w-full max-w-[640px] h-auto ">
                                    {(saveAiRun?.data?.ai_summary ||
                                      applicationDetails?.application
                                        ?.ai_summary) && (
                                      <div className="bg-[#ffeab6] p-5 rounded-xl mt-0 mb-12">
                                        <div className="flex items-center gap-[6px] mb-4">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                            aria-hidden="true"
                                            data-slot="icon"
                                            className="w-4 h-4 text-[#0000007a]"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                                            />
                                          </svg>

                                          <p className="text-[13px] leading-4 text-[#0000007a] font-medium uppercase">
                                            AI Summary
                                          </p>
                                        </div>
                                        <div className="text-[14px] text-[#000000eb] font-normal">
                                          {renderFormattedSummary(
                                            saveAiRun?.data?.ai_summary ||
                                              applicationDetails?.application
                                                ?.ai_summary,
                                          )}
                                        </div>
                                      </div>
                                    )}
                                    {applicationDetails?.application
                                      ?.app_summary && (
                                      <div>
                                        <div className="flex items-center mb-5 gap-x-3">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                            aria-hidden="true"
                                            data-slot="icon"
                                            className="w-4 h-4 text-dark-black-200 "
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                                            />
                                          </svg>
                                          <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
                                            Summary
                                          </span>
                                        </div>

                                        {
                                          applicationDetails?.application
                                            ?.app_summary
                                        }
                                      </div>
                                    )}
                                    {applicationDetails?.application
                                      ?.app_summary && (
                                      <hr className="my-8"></hr>
                                    )}

                                    {applicationDetails?.application
                                      ?.app_work && (
                                      <div className="mt-5">
                                        <div className="flex items-center justify-between mb-5 gap-x-3">
                                          <div className="flex items-center gap-x-3">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width={24}
                                              height={24}
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              strokeWidth={2}
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              className="icon icon-tabler icons-tabler-outline icon-tabler-briefcase-2 w-[1rem] h-[1rem] text-[#808080]"
                                            >
                                              <path
                                                stroke="none"
                                                d="M0 0h24v24H0z"
                                                fill="none"
                                              />
                                              <path d="M3 9a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9z" />
                                              <path d="M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2" />
                                            </svg>

                                            <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
                                              Experience
                                            </span>
                                          </div>
                                          <div
                                            className="table-tooltip before:!bottom-[-32px] before:!left-[17px]"
                                            data-title="Add Experience"
                                          >
                                            <button
                                              type="button"
                                              onClick={handleAddExperience}
                                              className="relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm
         font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none
          disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 border
         border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-6 w-6 "
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="icon icon-tabler icons-tabler-outline icon-tabler-plus w-[0.9rem] h-[0.9rem] text-[#808080]"
                                              >
                                                <path
                                                  stroke="none"
                                                  d="M0 0h24v24H0z"
                                                  fill="none"
                                                />
                                                <path d="M12 5l0 14" />
                                                <path d="M5 12l14 0" />
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                        <JobExperienceSection
                                          experienceData={
                                            applicationDetails.application
                                              .app_work
                                          }
                                          setapplicationDetails={
                                            setapplicationDetails
                                          }
                                          applicationIdByParent={applicationId}
                                        />
                                      </div>
                                    )}
                                    <hr className="mt-6 mb-8"></hr>
                                    {applicationDetails?.application
                                      ?.app_education && (
                                      <div className="mt-5">
                                        <div className="flex items-center justify-between mb-5 gap-x-3">
                                          <div className="flex items-center gap-x-3">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width={24}
                                              height={24}
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              strokeWidth={2}
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              className="icon icon-tabler icons-tabler-outline icon-tabler-vocabulary w-[0.9rem] h-[0.9rem] text-[#808080]"
                                            >
                                              <path
                                                stroke="none"
                                                d="M0 0h24v24H0z"
                                                fill="none"
                                              />
                                              <path d="M10 19h-6a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h6a2 2 0 0 1 2 2a2 2 0 0 1 2 -2h6a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-6a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2z" />
                                              <path d="M12 5v16" />
                                              <path d="M7 7h1" />
                                              <path d="M7 11h1" />
                                              <path d="M16 7h1" />
                                              <path d="M16 11h1" />
                                              <path d="M16 15h1" />
                                            </svg>
                                            <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
                                              Education
                                            </span>
                                          </div>
                                          <div
                                            className="table-tooltip before:!bottom-[-32px] before:!left-[17px]"
                                            data-title="Add Education"
                                          >
                                            <button
                                              type="button"
                                              onClick={handleAddEducation}
                                              className="relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm
         font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none
          disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 border
         border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-6 w-6 "
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="icon icon-tabler icons-tabler-outline icon-tabler-plus w-[1rem] h-[1rem] text-[#808080]"
                                              >
                                                <path
                                                  stroke="none"
                                                  d="M0 0h24v24H0z"
                                                  fill="none"
                                                />
                                                <path d="M12 5l0 14" />
                                                <path d="M5 12l14 0" />
                                              </svg>
                                            </button>
                                          </div>
                                        </div>

                                        <JobEducationSection
                                          educationData={
                                            applicationDetails.application
                                              .app_education
                                          }
                                          setapplicationDetails={
                                            setapplicationDetails
                                          }
                                        />
                                      </div>
                                    )}
                                    <hr className="mt-6 mb-8"></hr>
                                    <div className="mb-5 gap-x-3">
                                      <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-x-3">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-tabler icons-tabler-outline icon-tabler-bulb w-[1.1rem] h-[1.1rem] text-[#808080]"
                                          >
                                            <path
                                              stroke="none"
                                              d="M0 0h24v24H0z"
                                              fill="none"
                                            />
                                            <path d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7" />
                                            <path d="M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3" />
                                            <path d="M9.7 17l4.6 0" />
                                          </svg>

                                          <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
                                            Skills
                                          </span>
                                        </div>
                                        <div
                                          className="table-tooltip before:!bottom-[-32px] before:!left-[17px]"
                                          data-title="Add skills"
                                        >
                                          <button
                                            type="button"
                                            onClick={handleAddSkills}
                                            className="relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm
                                          font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none
                                          disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 border
                                          border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-6 w-6"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width={24}
                                              height={24}
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              strokeWidth={2}
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              className="icon icon-tabler icons-tabler-outline icon-tabler-plus w-[0.9rem] h-[0.9rem] text-[#808080]"
                                            >
                                              <path
                                                stroke="none"
                                                d="M0 0h24v24H0z"
                                                fill="none"
                                              />
                                              <path d="M12 5l0 14" />
                                              <path d="M5 12l14 0" />
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                      <div className="flex items-center gap-2 mt-5 flex-wrap">
                                        {parseSkills(
                                          applicationDetails.application
                                            ?.skills,
                                        ).map((skill, index) => (
                                          <div
                                            key={index}
                                            className="flex items-start w-fit bg-blue-100 text-blue-800 text-sm px-2 py-1 rounded-md"
                                          >
                                            {skill.trim()}
                                          </div>
                                        ))}
                                      </div>
                                    </div>

                                    {/* appQuestion */}

                                    {applicationResponseLoading ? (
                                      <div className="flex items-center justify-center h-[calc(50vh_-_56px)] w-full bg-white">
                                        <div className="simple-spinner-loader">
                                          <span></span>
                                        </div>
                                      </div>
                                    ) : (
                                      <>
                                        {applicationResponse?.length > 0 && (
                                          <>
                                            <div className="bg-[#e0e0e0] w-full h-[1px] mt-7 mb-8"></div>

                                            <div className="flex items-center gap-x-3 mb-7">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="icon icon-tabler icons-tabler-outline icon-tabler-library w-[1rem] h-[1rem] text-[#808080]"
                                              >
                                                <path
                                                  stroke="none"
                                                  d="M0 0h24v24H0z"
                                                  fill="none"
                                                />
                                                <path d="M7 3m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
                                                <path d="M4.012 7.26a2.005 2.005 0 0 0 -1.012 1.737v10c0 1.1 .9 2 2 2h10c.75 0 1.158 -.385 1.5 -1" />
                                                <path d="M11 7h5" />
                                                <path d="M11 10h6" />
                                                <path d="M11 13h3" />
                                              </svg>
                                              <span className="font-medium text-dark-black-200 mr-1 text-[15px] flex items-center gap-[6px]">
                                                Application responses
                                              </span>
                                            </div>

                                            <ul className="space-y-4">
                                              {applicationResponse &&
                                                applicationResponse.map(
                                                  (question, index) => (
                                                    <li
                                                      key={question.id}
                                                      className="relative flex gap-x-4"
                                                    >
                                                      <div className="relative flex-none w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center">
                                                        <span className="text-xs font-medium text-gray-700">
                                                          {
                                                            question.question_order
                                                          }
                                                        </span>
                                                      </div>
                                                      <div className="flex-auto rounded-md p-4 ring-1 ring-inset ring-gray-200">
                                                        <div className="w-full flex flex-col gap-2">
                                                          <div className="flex items-center">
                                                            <div className="flex-1">
                                                              <div className="flex flex-col gap-y-1">
                                                                <div className="flex items-center gap-x-1">
                                                                  <span className="font-normal text-[#374151] text-[14px] wg-antialiased leading-4">
                                                                    {
                                                                      question.question_title
                                                                    }
                                                                  </span>
                                                                </div>
                                                                <div className="bg-gray-200 w-full h-px my-2"></div>
                                                                <div className="flex flex-col gap-1">
                                                                  <span className="text-[0.8125rem] font-medium leading-4 text-[#1b1b1b] capitalize">
                                                                    {question.answer ||
                                                                      "-"}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </li>
                                                  ),
                                                )}
                                            </ul>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                        {currentPath === "resume" && (
                          <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="w-full">
                              <div className="w-full">
                                <JobResumeSection
                                  resumeData={
                                    applicationDetails?.application?.app_resume
                                  }
                                  sidebarOpen={sidebarOpen}
                                />
                              </div>
                            </div>
                          </div>
                        )}

                        {/* message  */}
                        {currentPath === "message" && (
                          <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                                  Messages
                                </h2>
                                <div className="bg-[#e0e0e0] w-full h-[1px] mt-4 mb-8"></div>
                                <JobMessageSection />
                              </div>
                            </div>
                          </div>
                        )}

                        {currentPath === "ai_interview" && (
                          <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                                 Ai Interview
                                </h2>
                                <div className="bg-[#e0e0e0] w-full h-[1px] mt-4 mb-8"></div>
                                <CandidateAiInterview />
                              </div>
                            </div>
                          </div>
                        )}

                        {currentPath === "team-discussion" && (
                          <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                                  Teams
                                </h2>
                                <div className="bg-[#e0e0e0] w-full h-[1px] mt-4 mb-8"></div>
                                <JobTeamDiscussion />
                              </div>
                            </div>
                          </div>
                        )}

                        {/* comment on 1/dec/2025 */}
                        {/* {currentPath === "notes" && (
                          <div className="flex-1 flex bg-white flex-col h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                                  Notes
                                </h2>
                                <div className="bg-[#e0e0e0] w-full h-[1px] mt-4 mb-8"></div>
                                <JobNotesSection />
                              </div>
                            </div>
                          </div>
                        )} */}
                        {/* comment on 1/dec/2025 */}
                        {/* {currentPath === "files" && (
                          <div className="flex-1 flex bg-white flex-col h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                                  Files
                                </h2>
                                <div className="bg-[#e0e0e0] w-full h-[1px] mt-4 mb-8"></div>
                                <JobFilesSection />
                              </div>
                            </div>
                          </div>
                        )} */}
                        {/* comment on 1/dec/2025 */}
                        {/* {currentPath === "scorecards" && !skillId && (
                          <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                                  Scorecards
                                </h2>
                                <div className="bg-[#e0e0e0] w-full h-[1px] mt-6 mb-6"></div>
                                <JobScorecardsSection />
                              </div>
                            </div>
                          </div>
                        )} */}

                        {skillId && (
                          <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                                  Scorecards
                                </h2>
                                <div className="bg-[#e0e0e0] w-full h-[1px] mt-4 mb-4"></div>
                                {isEditMode ? (
                                  <JobSkillScorecardEdit skillId={skillId} />
                                ) : (
                                  <JobSkillScorecard skillId={skillId} />
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        {currentPath === "questionnaire" && !QuestionsId && (
                          <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                                  questionnaire
                                </h2>
                                <div className="bg-[#e0e0e0] w-full h-[1px] mt-6 mb-6"></div>
                                <ApplicationQuestionnaireSection />
                              </div>
                            </div>
                          </div>
                        )}

                        {currentPath === "evaluation" && !appEvaluationId && (
                          <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                {/* <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                                  Evaluation 
                                </h2> */}

                                {/* <div className="flex items-center justify-between">
        <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize">
          Evaluation 
        </h2>
        <button
          // onClick={handleMeeting}
          className="group inline-flex shrink-0 select-none items-center justify-end text-[.8125rem] leading-6 transition-colors 
          duration-100 focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none 
          gap-0 px-[14px] font-medium  py-1 rounded-md text-white bg-indigo-600 h-[32px] hover:bg-indigo-500 focus-visible:outline-indigo-600"
          type="button"
        >
          <div className="flex items-center gap-[6px]">Create Evaluation</div>
        </button>
      </div>
                                <div className="bg-[#e0e0e0] w-full h-[1px] mt-6 mb-6"></div> */}
                                <ApplicationEvaluationSection />
                              </div>
                            </div>
                          </div>
                        )}

                        {QuestionsId && (
                          <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <Link
                                  to={`/${baseId}/job/${jobId}/app/${applicationId}/questionnaire`}
                                  className="flex items-center gap-x-1 w-full mb-4 ml-[-4px]"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left w-[0.9rem] h-[0.9rem]"
                                  >
                                    <path
                                      stroke="none"
                                      d="M0 0h24v24H0z"
                                      fill="none"
                                    />
                                    <path d="M15 6l-6 6l6 6" />
                                  </svg>
                                  <span className="text-black-100 text-[13px]">
                                    Back to Questionnaire
                                  </span>
                                </Link>
                                <QuestionSetDetails QuestionsId={QuestionsId} />
                              </div>
                            </div>
                          </div>
                        )}

                        {currentPath === "meetings" && !meetingId && (
                          <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <MeetingSection
                                  applicationDetails={
                                    applicationDetails.application
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        )}

                        {meetingId && (
                          <div className="flex-1 flex flex-col bg-white  h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <Link
                                  to={`/${baseId}/job/${jobId}/app/${applicationId}/meetings`}
                                  className="flex items-center gap-x-1 w-full mb-4 ml-[-4px]"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left w-[0.9rem] h-[0.9rem]"
                                  >
                                    <path
                                      stroke="none"
                                      d="M0 0h24v24H0z"
                                      fill="none"
                                    />
                                    <path d="M15 6l-6 6l6 6" />
                                  </svg>
                                  <span className="text-black-100 text-[13px]">
                                    Back to Meeting
                                  </span>
                                </Link>
                                <MeetingDetails meetingId={meetingId} />
                              </div>
                            </div>
                          </div>
                        )}

                        {currentPath === "appreview" && !appreviewId && (
                          <div className="flex-1 flex flex-col bg-white  h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <AppReviewSection
                                  applicationDetails={
                                    applicationDetails.application
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        )}

                        {appreviewId && (
                          <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <Link
                                  to={`/${baseId}/job/${jobId}/app/${applicationId}/appreview`}
                                  className="flex items-center gap-x-1 w-full mb-4 ml-[-4px]"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left w-[0.9rem] h-[0.9rem]"
                                  >
                                    <path
                                      stroke="none"
                                      d="M0 0h24v24H0z"
                                      fill="none"
                                    />
                                    <path d="M15 6l-6 6l6 6" />
                                  </svg>
                                  <span className="text-black-100 text-[13px]">
                                    Back to App Review
                                  </span>
                                </Link>
                                <AppReviewDetails
                                  meetingId={appreviewId}
                                  setConductReview={setConductReview}
                                  conductReview={conductReview}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        {appEvaluationId && (
                          <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <Link
                                  to={`/${baseId}/job/${jobId}/app/${applicationId}/evaluation`}
                                  className="flex items-center gap-x-1 w-full mb-4 ml-[-4px]"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left w-[0.9rem] h-[0.9rem]"
                                  >
                                    <path
                                      stroke="none"
                                      d="M0 0h24v24H0z"
                                      fill="none"
                                    />
                                    <path d="M15 6l-6 6l6 6" />
                                  </svg>
                                  <span className="text-black-100 text-[13px]">
                                    Back
                                  </span>
                                </Link>
                                <AppEvaluationDetails
                                  meetingId={appreviewId}
                                  evUserId={appEvaluationId}
                                  setConductReview={setConductReview}
                                  conductReview={conductReview}
                                />
                              </div>
                            </div>
                          </div>
                        )}

                        {currentPath === "activity" && (
                          <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                                  Activity
                                </h2>
                                <div className="bg-[#e0e0e0] w-full h-[1px] mt-6 mb-6"></div>
                                <JobActivity />
                              </div>
                            </div>
                          </div>
                        )}

                        {currentPath === "journey" && (
                          <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[50px] px-0 lg:px-10 overflow-auto">
                            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
                              <div className="w-full max-w-[640px]">
                                <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                                  {" "}
                                  App Journey
                                </h2>
                                <div className="bg-[#e0e0e0] w-full h-[1px] mt-4 mb-8"></div>
                                <Journey />
                              </div>
                            </div>
                          </div>
                        )}
                      </>

                      <div    className={`max-w-[300px] w-full border-l border-gray-200 pt-0 bg-white rounded-tr-lg rounded-br-lg ${isChatOpen ? "hidden" : "block"}`}>
                        <div className="p-3">
                          <h2 className="text-gray-600 px-3 font-medium text-[0.8125rem] mb-3">
                            Candidate Details
                          </h2>
                          {applicationDetails?.application?.ai_rating && (
                            <span
                              className={`inline-flex mx-2 my-0 mb-2 w-fit items-center rounded-md ${styles1.bg} px-2 py-1 text-xs font-normal ${styles1.text} ring-1 ring-inset ${styles1.ring}`}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                aria-hidden="true"
                                data-slot="icon"
                                className={`w-3 h-3 mr-[6px] ${styles1.text} `}
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                                />
                              </svg>
                              AI:
                              <span className="ml-[4px]">
                                {getRatingLabel(
                                  applicationDetails?.application?.ai_rating,
                                )}
                                <span className="ml-[2px]">{`(${applicationDetails?.application?.ai_rating})`}</span>
                              </span>
                            </span>
                          )}

                          {applicationDetails?.application?.user_rating && (
                            <span
                              className={`flex mt-0 mb-2 mx-2   w-fit items-center rounded-md ${styles.bg} px-2 py-1 text-xs font-normal ${styles.text} ring-1 ring-inset ${styles.ring}`}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className={`icon icon-tabler icons-tabler-outline icon-tabler-users w-3 h-3 mr-[6px] ${styles.text} `}
                              >
                                <path
                                  stroke="none"
                                  d="M0 0h24v24H0z"
                                  fill="none"
                                />
                                <path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                                <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
                              </svg>
                              User:
                              <span className="ml-[4px]">
                                {getSkillLevelLabel(
                                  applicationDetails?.application?.user_rating,
                                )}
                                <span className="ml-[2px]">{`(${applicationDetails?.application?.user_rating})`}</span>
                              </span>
                            </span>
                          )}

                          <CandidateDetails
                            applicationDetails={applicationDetails}
                            baseId={baseId}
                            jobId={jobId}
                            applicationId={applicationId}
                            setapplicationDetails={setapplicationDetails}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* experience  */}
          <Dialog
            open={isModalOpen}
            onClose={setIsModalOpen}
            className="relative z-10"
          >
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                  <h3 className="text-base font-semibold leading-6 text-gray-900">
                    Add New Experience
                  </h3>
                  <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                    <button
                      type="button"
                      onClick={() => setIsModalOpen(false)}
                      className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      <span className="sr-only">Close</span>
                      <CrossIcon aria-hidden="true" className="size-6" />
                    </button>
                  </div>
                  <div className="grid gap-4 py-4 mt-1">
                    <div className="grid gap-[6px]">
                      <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                        Company <span className="text-red-500">*</span>
                      </label>
                      <input
                        name="company"
                        value={newExperienceForm.company}
                        onChange={handleInputChange}
                        className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                      />
                    </div>
                    <div className="grid gap-[6px]">
                      <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                        Designation <span className="text-red-500">*</span>
                      </label>
                      <input
                        name="designation"
                        value={newExperienceForm.designation}
                        onChange={handleInputChange}
                        className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                      />
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <CustomDropdown
                        label="Start Month"
                        value={newExperienceForm.startDateMonth}
                        onChange={handleInputChange}
                        options={months}
                        name="startDateMonth"
                      />
                      <CustomDropdown
                        label="Start Year"
                        value={newExperienceForm.startDateYear}
                        onChange={handleInputChange}
                        options={years}
                        name="startDateYear"
                      />
                    </div>
                    <div className="grid gap-[6px] mt-[-10px]">
                      <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5 w-[100px]">
                        <input
                          type="checkbox"
                          name="isCurrentJob"
                          checked={newExperienceForm.isCurrentJob}
                          onChange={handleInputChange}
                          className="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                        />
                        Current Job
                      </label>
                    </div>

                    {!newExperienceForm.isCurrentJob && (
                      <div className="grid grid-cols-2 gap-4">
                        <CustomDropdown
                          label="End Month"
                          value={newExperienceForm.endDateMonth}
                          onChange={handleInputChange}
                          options={months}
                          name="endDateMonth"
                        />
                        <CustomDropdown
                          label="End Year"
                          value={newExperienceForm.endDateYear}
                          onChange={handleInputChange}
                          options={years}
                          name="endDateYear"
                        />
                      </div>
                    )}
                    <JobWorkplaceTypeListbox
                      value={workplaceType}
                      onChange={handleWorkplaceTypeChange}
                    />
                    <div className="grid gap-[6px]">
                      <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                        Location
                      </label>
                      <JobEduLocationModal
                        items={locations}
                        buttonText="Search by city, state, or country"
                        onChange={handleLocationChange}
                        selectedItem={selectedCountry}
                        isLoading={loadingLocation}
                      />
                    </div>
                    <div className="grid gap-[6px]">
                      <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                        Description
                      </label>
                      <textarea
                        id="description"
                        name="description"
                        rows={4}
                        onChange={handleInputChange}
                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        value={newExperienceForm.description}
                      />
                    </div>
                  </div>

                  <div className="flex justify-end gap-4 mt-5">
                    <button
                      className="rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                      onClick={() => setIsModalOpen(false)}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmit}
                      className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      <div className="flex items-center gap-[6px]">
                        Save
                        {isLoading && (
                          <div className="simple-spinner">
                            <span></span>
                          </div>
                        )}
                      </div>
                    </button>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </Dialog>

          {/* education  */}

          <Dialog
            open={isModalOpenEdu}
            onClose={setIsModalOpenEdu}
            className="relative z-10"
          >
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                  <h3 className="text-base font-semibold leading-6 text-gray-900">
                    Add New Education
                  </h3>
                  <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                    <button
                      type="button"
                      onClick={() => setIsModalOpenEdu(false)}
                      className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      <span className="sr-only">Close</span>
                      <CrossIcon aria-hidden="true" className="size-6" />
                    </button>
                  </div>
                  <div className="grid gap-4 py-4 mt-1">
                    <div className="grid gap-[6px]">
                      <label
                        htmlFor="course"
                        className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                      >
                        Course <span className="text-red-500">*</span>
                      </label>
                      <input
                        id="course"
                        name="course"
                        value={newEducationForm?.course}
                        onChange={handleInputChangeEducation}
                        className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                    duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                   dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                      />
                    </div>
                    <div className="grid gap-[6px]">
                      <label
                        htmlFor="course"
                        className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                      >
                        University
                      </label>
                      <input
                        id="university"
                        name="university"
                        value={newEducationForm?.university}
                        onChange={handleInputChangeEducation}
                        className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                    duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                   dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                      />
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="grid gap-[6px]">
                        <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                          Start Date
                        </label>
                        <div className="grid grid-cols-2 gap-2">
                          <CustomDropdown
                            value={newEducationForm.start_month}
                            onChange={handleInputChangeEducation}
                            options={months}
                            name="start_month"
                            placeholder="Month"
                          />
                          <CustomDropdown
                            value={newEducationForm.start_year}
                            onChange={handleInputChangeEducation}
                            options={years}
                            name="start_year"
                            placeholder="Year"
                          />
                        </div>
                      </div>
                      <div className="grid gap-[6px]">
                        <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                          End Date
                        </label>
                        <div className="grid grid-cols-2 gap-2">
                          <CustomDropdown
                            value={newEducationForm.end_month}
                            onChange={handleInputChangeEducation}
                            options={months}
                            name="end_month"
                            placeholder="Month"
                          />
                          <CustomDropdown
                            value={newEducationForm.end_year}
                            onChange={handleInputChangeEducation}
                            options={years}
                            name="end_year"
                            placeholder="Year"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="grid gap-[6px]">
                      <label
                        htmlFor="course"
                        className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                      >
                        Location
                      </label>
                      <JobEduLocationModal
                        items={locations}
                        buttonText="Search by city, state, or country"
                        onChange={handleLocationChangeEdu}
                        selectedItem={selectedCountryEdu}
                        isLoading={loadingLocationEdu}
                      />
                    </div>
                    <div className="grid gap-[6px]">
                      <label
                        htmlFor="course"
                        className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                      >
                        Specialization
                      </label>
                      <input
                        id="branch"
                        name="branch"
                        value={newEducationForm?.branch}
                        onChange={handleInputChangeEducation}
                        className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                    duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                   dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                      />
                    </div>
                    <div className="grid gap-[6px]">
                      <label
                        htmlFor="course"
                        className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                      >
                        Grade
                      </label>
                      <input
                        id="grade"
                        name="grade"
                        type="text"
                        value={newEducationForm.grade}
                        onChange={handleInputChangeEducation}
                        className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                     duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                    dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                      />
                    </div>
                    <div className="grid gap-[6px]">
                      <label
                        htmlFor="description"
                        className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                      >
                        Description
                      </label>
                      <textarea
                        id="description"
                        name="description"
                        rows={4}
                        value={newEducationForm?.description}
                        onChange={handleInputChangeEducation}
                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                      />
                    </div>
                  </div>

                  <div className="flex justify-end gap-4 mt-5">
                    <button
                      className="rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                      onClick={() => setIsModalOpenEdu(false)}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmitEdution}
                      className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      <div className="flex items-center gap-[6px]">
                        Save
                        {isLoadingEdu && (
                          <div className="simple-spinner">
                            <span></span>
                          </div>
                        )}
                      </div>
                    </button>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </Dialog>

          {/* skills */}
          <Dialog
            open={isSkillModalOpen}
            onClose={setIsSkillModalOpen}
            className="relative z-10"
          >
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                  <h3 className="text-base font-semibold leading-6 text-gray-900">
                    Add New Skills <span className="text-red-500">*</span>
                  </h3>
                  <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                    <button
                      type="button"
                      onClick={() => setIsSkillModalOpen(false)}
                      className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      <span className="sr-only">Close</span>
                      <CrossIcon aria-hidden="true" className="size-6" />
                    </button>
                  </div>
                  <div className="space-y-2 md:space-y-4 lg:space-y-4">
                    <SkillsInput
                      value={selectedSkills}
                      onChange={setSelectedSkills}
                      required={true}
                    />
                  </div>

                  <div className="flex justify-end gap-2 mt-5">
                    <button
                      className="rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                      onClick={() => setIsSkillModalOpen(false)}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmitSkills}
                      className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      <div className="flex items-center gap-[6px]">
                        Save
                        {isSkillLoading && (
                          <div className="simple-spinner">
                            <span></span>
                          </div>
                        )}
                      </div>
                    </button>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </Dialog>
        </>
      )}
      {isConductReview && (
        <CandidateReviewLayout
          isOpenHeader={isOpenHeader}
          setIsOpenHeader={setIsOpenHeader}
          selectedFilterHeader={selectedFilterHeader}
          setSelectedFilterHeader={setSelectedFilterHeader}
          optionsWithAllStagesHeader={optionsWithAllStagesHeader}
          applicationDetails={applicationDetails}
          setapplicationDetails={setapplicationDetails}
          isConductReview={isConductReview}
          appreviewId={appreviewId}
          appreviewId1={appreviewId1}
          QuestionsId={appreviewId1}
          setIsLoadingApp={setIsLoadingApp}
          isLoadingApp={isLoadingApp}
        />
      )}
      <AiWidgetsComponent page={'candidateLayout'} />
    </>
  );
};

export default CandidateLayout;
